const { options } = require('../options')
let data = require('./zh_z')

module.exports = {
  message: {
    ...data,
    cashbackCollectionLink: '收款链接',
    cashbackCollectionDetails: '收款链接明细',
    cashbackAmountYuan: '金额（元）',
    cashbackCollectionReason: '收款原因',
    cashbackListLoadFailed: '收款链接列表加载失败',
    cashbackListRetry: '重试',
    cashbackCreateLink: '创建收款链接',
    cashbackGenerateNow: '立即生成',
    cashbackAmountPlaceholder: '请输入金额',
    cashbackReasonPlaceholder: '请输入收款原因',
    cashbackAmountInvalid: '请输入大于0、不超过99999999.99的金额，最多两位小数',
    cashbackReasonRequired: '请输入收款原因',
    cashbackReasonTooLong: '收款原因不能超过60000字节（UTF-8）',
    cashbackCreateUnconfirmed: '上次提交结果尚未确认，请重试确认，金额和收款原因暂不可修改。',
    cashbackVoidTitle: '废弃提示',
    cashbackVoidMessage: '废弃收款链接后，收款链接将无法支付，直接失效，该操作无法回退，请确认后废弃。',
    cashbackConfirmDelete: '确认删除',
    language: '语言',
    logOut: '退出登录',
    Chinese: '中文',
    Japanese: '日文',
    allPersonnel: '全部人员',
    permanentWorker: '正式工',
    temporaryWorker: '临时工',
    addMembers: '成员添加',
    systemAccount: '系统账号',
    name: '姓名',
    phoneNumber: '手机号',
    employeeId: '员工ID',
    setDefaultSealer: '设置封箱人',
    defaultSealer: '封箱人',
    selectDefaultSealer: '请选择封箱人',
    sealerCandidatesLoadFailed: '封箱候选人员加载失败',
    reloadSealerCandidates: '重新加载',
    defaultSealerProgress: '设置进度',
    porderWaitSeal: '待封箱',
    porderSealed: '封箱完成',
    adjustPorderSealer: '调整封箱员',
    porderSealer: '封箱员',
    batchSealPorders: '批量封箱',
    sealPorder: '封箱',
    confirmSealingComplete: '确认将所选配送单标记为封箱完成？操作后无法回退，请确认操作。',
    sealingPorderLimit: '请选择1至200个有效配送单',
    scopeOfPersonnel: '人员范围',
    shelfUserPersonnel: '使用人员',
    typeOfWork: '工种',
    newTypeOfWork: '工种:',
    search: '搜索',
    reset: '重置',
    typeOfAccount: '账号类别',
    realname: '真实姓名',
    sex: '性别',
    phone: '电话',
    chatDisplayName: '聊天显示名称',
    chatGroup: '聊天群组',
    newChatGroup: '聊天群组:',
    role: '角色',
    automaticSinglePrefix: '自动下单前缀',
    automaticallyOrderCustomParts: '自动下单自定义部分',
    youCanEnterSubsystemSettings: '可进入子系统设置',
    accountStatus: '可进入子系统设置',
    operation: '操作',
    operatingPersonne: '操作人员',
    accountToEdit: '账号编辑',
    editRole: '角色编辑',
    whetherToEnableTheAccount: '是否将此账号设置为启用状态',
    whetherToDisableTheAccount: '是否将此账号设置为停用状态',
    hint: '提示',
    confirm: '确 定',
    cancel: '取 消',
    theSettingsHaveBeenCancelled: '已取消设置',
    sectoralStructure: '部门结构',
    add: '添加',
    redact: '编辑',
    delete: '删除',
    checkWhetherToDeleteTheCurrentLevelTheContentContainedInTheLevelWillBeDeletedSimultaneously: '确认是否删除当前层级，层级下包含内容会同步删除',
    editorialDepartment: '编辑部门',
    superiorDepartment: '上级部门:',
    clickTheDepartmentOptionToSearchAndDisplayTheCurrentDepartmentByDefault: '点击部门选项，可以搜索，默认显示当前部门',
    industryTitle: '部门名称:',
    newSubordinateDepartments: '新增下级部门',
    save: '保存',
    sureToClose: '确认关闭？',
    requiredFieldsAreMissing: '缺少必填项',
    organizationalStructure: '组织架构',
    usersList: '用户列表',
    editMemberInformation: '编辑成员信息',
    accountType: '账户类型:',
    newSystemAccount: '系统账号:',
    pleaseEnterTheSystemAccount: '请输入系统账号',
    systemHeadImage: '系统头像',
    pleaseEnterTheSystemHeadImage: '请选择系统头像',
    password: '密码:',
    enterYourPIN: '请输入密码',
    newRealname: '真实姓名:',
    pleaseEnterYourRealname: '请输入真实姓名:',
    newSex: '性别：',
    man: '男',
    girl: '女',
    telephoneNumber: '电话号码',
    return: '返回',
    pleaseEnterAChatName: '请输入聊天名称',
    pleaseEnterThePhoneNumber: '请输入电话号码',
    newPleaseEnterYourRealname: '请输入真实姓名',
    whetherToAddTheAccount: '是否添加该账号',
    theAdditionHasBeenCanceled: '已取消添加',
    whetherToModifyTheAccountInformation: '是否修改该账号的信息',
    modificationCancelled: '已取消修改',
    rolename: '角色名',
    theNewRole: '新增角色',
    characterName: '角色名称',
    organization: '组织',
    rolePermission: '角色权限',
    theRoleList: '角色列表',
    editingTheRole: '编辑角色',
    newCharacterName: '角色名称:',
    pleaseEnterARoleName: '请输入角色名称',
    typeOfWorkToChoose: '工种选择',
    department: '部门',
    automaticallyJoiningAGroup: '自动加入群组',
    doNotAutomaticallyJoinGroups: '不自动加入群组',
    pleaseSelectTheTypeOfWork: '请选择工种',
    pleaseSelectDepartment: '请选择部门',
    whetherToAddTheRole: '是否添加该角色',
    whetherToModifyTheRole: '是否修改该角色的信息',
    permissionSetting: '权限设置',
    menuPermissions: '菜单权限',
    operatingAuthorization: '操作权限',
    whetherToDeleteTheRole: '是否删除该角色',
    theDeletionHasBeenCancelled: '已取消删除',
    editRolesAndAccessSystemInformation: '编辑角色、可进入系统信息',
    accessToSubsystems: '可进入子系统：',
    pleaseSelectSubsystem: '请选择子系统',
    newRole: '角色：',
    pleaseSelectRoles: '请选择角色',
    roleChoices: '角色选择',
    whetherToSaveTheRoleBoundToTheAccountAndTheInformationThatCanBeAccessedToTheSystem: '是否要保存该账号绑定的角色和可进入系统信息',
    orderAddressSetting: '下单地址设置',
    notToChoose: '未选择',
    accountStatus: '账号状态',
    automaticallyAdd: '自动加入',
    notAutomaticallyAdded: '不自动加入',
    checkProductAttributes: '检品属性',
    configurationOfInspectionProperties: '检品属性配置',
    allocationProportion: '分配比例',


    speechLanguage: 'español', //西班牙语
    productProblem: '产品问题',
    customerData: '客户资料',
    customerFeedback: '客户意见',
    personnelManagement: '人员管理',
    unit: '元',
    Yen: '円',
    salesman: '业务员',
    logOut: '退出登录',
    orderForm: '订单',
    customerManagement: '客户管理',
    itemStatus: '商品状态',
    department: '部门',
    screenPeers: '筛选同层级人员',
    clickOnTheDepartmentOptionToSearch: '点击部门选项，可以搜索',
    internationalLogisticsMaintenance: '国际物流维护',
    sortNumber: '排序编号',
    logisticsId: '物流ID',
    sendingModeName: '发送方式名称',
    sendModeLogo: '发送方式logo',
    currentEffectiveTime: '当前生效时间',
    currentFreightCalculationMode: '当前运费计算模式',
    availableQuantityOfLogisticsTrackingNumber: '物流单号可用数量',
    currentSendingStatus: '当前发送状态',
    editTheDetails: '编辑详情',
    setTheSort: '设置排序',
    normalHair: '正常发',
    stopHair: '停发',
    LogisticsModeAddedTheForm: '物流方式新增表单',
    pleaseEnterTheNameOfTheNewLogisticsMode: '请输入新增的物流方式的名称',
    pleaseSelectTheLogisticsLogo: '请选择物流logo',
    logisticsLogo: '物流logo',
    whetherToDeleteTheSelectedLogistics: '是否删除选中的物流',
    whetherToChangeTheCurrentSendingStatusOfTheSelectedLogisticsToNormalSending: '是否将选中物流的当前发送状态修改为正常发',
    determineWhetherToChangeTheBookingStatusOfTheSelectedLogisticsToYes: '是否将选中物流的订柜状态修改为是',
    whetherToChangeTheCurrentSendingStatusOfTheSelectedLogisticsToStopSending: '是否将选中物流的当前发送状态修改为停发',
    whetherToChangeTheBookingStatusOfTheSelectedLogisticsToNo: '是否将选中物流的订柜状态修改为否',
    modificationCancelled: '已取消修改',
    whetherToSubmitTheLogisticsSortingModification: '是否提交物流排序修改',
    are: '是',
    no: '否',
    effectiveTime: '生效时间',
    modificationDate: '最后修改时间',
    freightCalculationMode: '运费计算模式',
    overviewOfCalculationRules: '计算规则概述',
    effectiveState: '生效状态',
    takeEffect: '生效',
    invalid: '未生效',
    editView: '编辑查看',
    toCopyA: '复制一条',
    newManualQuotationRules: '新人工报价规则',
    effectiveStartTime: '生效开始时间',
    validityEndTime: '生效结束时间',
    addedManualQuotationRules: '新增人工报价规则',
    setSpecificComputingRules: '具体计算规则设置',
    logisticsModeNumber: '物流方式编号',
    activeElementSettingsInRealTime: '实时生效元素设置',
    stateOfLogisticsMode: '物流方式状态',
    initiation: '开始',
    end: '结束',
    doYouNeedToBookAContainer: '是否需要订柜',
    expectedDaysInSpain: '预计西班牙天数',
    pleaseEnterTheExpectedDaysToSpain: '请输入预计到西班牙天数',
    whetherToChangeTheEffectiveStatusOfTheLogisticsCalculationRuleToEffective: '是否将物流计算规则的生效状态修改为生效',
    whetherToChangeTheEffectiveStatusOfTheLogisticsCalculationRuleToInvalid: '是否将物流计算规则的生效状态修改为未生效',
    theFormatOfUploadedImageResourceIsNotCorrect: '上传图片资源格式不正确',
    whetherToSaveTheLogisticsConfiguration: '是否保存物流配置',
    selectATimeForTheValidityToStart: '请选择生效开始时间',
    selectAnEndTimeForTheValidityPeriod: '请选择生效结束时间',
    revisedManualQuotationRules: '修改人工报价规则',
    saveSettings: '保存设置',
    proportionSet: '比例设置',
    theTotalNumberOfCustomers: '客户总数',
    accountNumber: '账号',
    role: '角色',
    departmentNumber: '部门成员',
    customerAllocationRatio: '客户分配比例',
    customerAllocation: '客户分配',
    customerIDMaybeOrderNumber: '客户ID/订单号',
    inquire: '查询',
    reset: '重置',
    advancedFilter: '高级筛选',
    allocation: '分配',
    clientID: '客户ID',
    customerName: '客户名',
    UserName: '用户名',
    loginName: '登录账号',
    typeOfAccount: '账号类别',
    cellphoneNumber: '手机号',
    clientGrade: '客户等级',
    takeOn: '担当',
    authorityManagement: '权限管理',
    roleManagement: '角色管理',
    roleRightsAssignment: '角色权限分配',
    commodityMaterial: '品名材质',
    EstimateTheCostOfInternationalTransport: "预估国际运输费用",
    EstimatedDomesticDeliveryCostsInSpain: "预估西班牙国内派送费用",
    whetherToRecommend: '是否推荐',
    whetherTheStartingVolumeIsReached: '是否达到起发量',
    StartingVolumeRemarks: '起发量备注',
    EnterAgain: '重新输入',
    roleName: '角色名',
    typeOfWork: '工种',
    organization: '组织',
    creationTime: '创建时间',
    operation: '操作',
    returnsAListOf: '返回列表',
    menuPermissions: '菜单权限',
    operatingAuthorization: '操作权限',
    save: '保存',
    temporaryStorage: '临时保存',
    generateSystemPurchaseNo: '生成系统交易号',
    purchase: '采购',
    distribution: '配货',
    customerStatus: '客户状态',
    balance: '残高(円)',
    introducer: '介绍人',
    deliveryOrderAuthorization: '配送单授权',
    goldenAuthorization: '入金授权',
    registrationDate: '注册时间',
    lastVisitTime: '最近访问时间',
    particulars: '详情',
    businessOrder: '业务订单',
    theOrderPrice: '订单报价',
    startDate: '开始日期',
    startDateTC: '开始日期（提出）',
    dateClosedTC: '结束日期（提出）',
    dateClosed: '结束日期',
    search: '搜索',
    orderSubmissionTime: '提交订单时间',
    confirmCompletionTime: '确认完成时间',
    confirmCompletion: '确认完成',
    theOrderAttribute: '订单属性',
    orderNumber: '订单号',
    order: '单号',
    business: '业务',
    ordersNumber: '订单番数',
    quotationStatus: '报价状态',
    serviceOrderRemarks: '业务订单备注',
    purchaseOrderRemarks: '采购订单备注',
    property: '属性',
    compile: '编辑',
    orderConfirmation: '订单确认',
    customerPresentationTime: '客户提出时间',
    translationTime: '翻译完了时间',
    ordersForTranslation: '订单翻译',
    orderInProgress: '进行中订单',
    selectionOfSalesman: '选择业务员',
    purchasingAgentSelection: '选择采购员',
    selectADistributor: '选择配货员',
    orderNumberMaybeCustomerName: '订单号/客户名称',
    orderDistribution: '订单号/配送单号',
    userName: '客户名称',
    adjustTheBusiness: '调整业务',
    adjustTheArchitecture: '调整架构',
    adjustTheDistribution: '调整配货',
    deleteTheOrder: '删除订单',
    withdrawTheRemainingCash: '回退待入金',
    operator: '操作员',
    translate: '翻译',
    notarize: '确认',
    quotedPrice: '报价',
    quotedPriceNum: '报价数',
    customersIntoGold: '客户入金',
    golden: '入金',
    financialConfirmationOfTheDeposit: '财务确认入金',
    financialConfirmation: '确认入金',
    financialPayment: '财务付款',
    signForTime: '签收时间',
    hitTheShelf: '上架',
    hitTheShelfComplete: '上架完成',
    shelfCompletionTime: '上架完成时间',
    wholeOrderShelfCompleted: '整单是否上架完了',
    shelfCompletedLabel: '上架完了',
    shipmentComplete: '出货完成',
    purchaseComplete: '采购完成',
    buyer: '采购员',
    distributionMember: '配货员',
    numberOfStores: '店铺数',
    numberOfGoods: '商品数',
    recipients: '收件人',
    recipientsPhone: '收件人电话',
    purchaseOrders: '订单采购',
    finishedPurchaseOrder: '购买完了订单',
    paymentOfAnOrder: '订单支付',
    paymentOfAnPorder: '配送单支付',
    businessOffer: '业务报价',
    orderSubmissionDate: '订单提交日期',
    confirmTheTime: '确认完了时间',
    setsetWebsite: '网站配置',
    classifyManage: '分类管理',
    CommodityClassification: '商品主分类',
    DefaultPersonalizedRecommendation: '默认个性化推荐',
    GeneralProductrecommendation: '普通商品推荐',
    AddTheClassification: '添加分类',
    ChineseName: '中文名称',
    translationName: '译文名称',
    sort: '排序',
    TheCigherClassification: '上级分类',
    defaultIcon: 'Web默认图标',
    triggerIcon: 'Web悬停图标',
    appImg: 'App图标',
    note: '描述',
    cancel: '取消',
    editClassification: '编辑分类',
    areYouSureToDelete: '是否确定删除？',
    prompt: '提示',
    confirmTheShutDown: '确认关闭？',
    pleaseChineseName: '请输入中文名称',
    KeywordsEnteredByTheCustomer: '客户输入的关键词',
    pleaseTranslationName: '请输入译文名称',
    theHigherTheNumber: '*数字越大越靠前',
    setCarousel: '轮播图设置',
    resultspreview: '效果预览',
    rollingFrequency: '滚动频率',
    carousel1: '注：保存生效',
    carousel2: '注：未保存，之前操作无效',
    instructions: '说明',
    seconds: '秒',
    addBanner: '添加Banner',
    skipLinks: '跳转链接',
    delete: '删除',
    status: '状态',
    allStatus: '全部状态',
    all: '全部',
    bannerConfiguration: 'Banner配置',
    staticBannerEdit: '静态横幅编辑',
    bannerMainTitle: '大标题',
    bannerSubtitle: '小标题',
    newColumn: '新着栏目',
    readMore: '查看详情',
    enterReasonForDeletion: '填写删除原因',
    adjustBusiness: '调整业务',
    adjustPurchase: '调整采购',
    adjustdistribution: '调整配货',
    deleteOrder: '删除订单',
    withdrawRemaining: '回退待入金',
    storeInformation: '店铺信息',
    pic: '照片',
    commodityAttribute: '商品属性 ',
    standardCommodityCategory: '标准商品类别 ',
    standardGoods: '标准品名 ',
    standardMaterial: '标准材质 ',
    category: '类别',
    setName: '设置人',
    setStandard: '设置标准',
    allSetStandard: '批量设置标准',
    entryTime: '录入时间',
    material: '品名',
    texture: '材质',
    isSertificate: '是否需要证书',
    standardInformation: '标准信息 ',
    fllStandardInformation: '填充到标准信息',
    need: '需要',
    noNeed: '不需要',
    homePreview: '首页预览',
    commodityMaintenance: '品名维护',
    goodsReplacement: '商品更换 ',
    SyncHome: '同步到首页',
    recommend: '为你推荐',
    ok: '确定',
    modifyGoods: '修改商品',
    uoloadPic: '上传图片',
    originalGoods: '商品原图',
    previewPicture: '图片预览',
    originalNameCommodity: '商品原名称',
    translationCorrect: '译文修正',
    homePreviewAffirm: '确认之后商品原信息将会替换，是否确认?',
    financial: '财务',
    financialStoreList: '待确认汇款',
    forwardTime: '提出时间',
    accountingCategory: '账务类别',
    user: '客户',
    orderInformations: '单子信息',
    orderSum: '单子金额(€)',
    sum: '金额',
    methodPayment: '支付方式',
    nameRemitter: '汇款人姓名',
    name: '姓名',
    phone: '电话',
    remittanceAmount: '汇款金额',
    remittanceScreenshots: '汇款截图',
    transferNote: '转账备注',
    accountBalance: '账户余额(€)',
    accountBalance1: '账户余额',
    creditAmount: '可赊账金额',
    edit: '修改',
    rollback: '回退',
    confirmAmount: '确认后汇款额将在客户余额反应，请谨慎操作！',
    returnedAmount: '确认后将回退到待汇款状态，请谨慎操作！',
    rulePay_realname: '请输入汇款人姓名',
    rulePay_amount: '请输入汇款金额(€)',
    ruleBill_method: '请选择支付方式',
    rulePay_image: '请上传汇款截图',
    rulePay_remark: '请输入转账备注',
    ruleUser_id: '请输入客户ID',
    manualRegistrationRemittance: '人工登记汇款',
    add: '新增',
    acknowledgingTime: '确认时间',
    emittanceState: '汇款状态',
    affirmName: '确认人',
    addName: '追加人',
    confirmed: '已确认',
    toBeConfirmed: '待确认',
    productPicture: '商品图片',
    chineseProductName: '中文商品名',
    productCategory: '商品类别',
    material: '品名',
    texture: '材质',
    materialCN: '品名（CN）',
    textureCN: '材质（CN）',
    materialSpain: '品名（Spain）',
    textureSpain: '材质（Spain）',
    materialEN: '品名（EN）',
    textureEN: '材质（EN）',
    customerPlacesAnOrder: '客户下单',
    quotationInStock: '报价在库数',
    quotationUnitPrice: '报价单价',
    quoteDomesticShipping: '报价国内运费',
    productCategorySelection: '商品类别选择',
    choose: '选择',
    commodityCategory: '商品品类',
    taxRate: '税率',
    whetherToSubmitProductNameEditing: '是否提交品名编辑?',
    submissionCancelled: '已取消提交',
    chooseSuccess: '选择成功!',
    investigateTheNumberOfInStock: '调查在库数',
    referenceUnitPrice: '参考单价',
    investigateDomesticShippingCosts: '调查国内运费',
    surveyUnitPrice: '调查单价',
    confirmDomesticShipping: '确认国内运费',
    volume: '体积',
    singleBoxVolume: '单箱体积',
    packingQuantity: '装箱量',
    singleNetWeight: '单个净重(g)',
    additionalServices: '附加服务',
    additionalServicesChinese: '附加服务中文名',
    additionalServicesJapanese: '附加服务日文名',
    warning: '警告',
    commodityBoxSizeWeight: '商品箱规/重量',
    businessReply: '业务回复',
    requiredFieldsAreMissing: '缺少必填项',
    noBuyerOrDistributorIsAssignedToThisOrder: '该订单未分配采购员和配货员',
    purchasingNotes: '采购备注',
    customerSingleNote: '客户单番备注',
    customerProductRemarks: '客户商品备注',
    businessTranslation: '业务翻译',
    businessTranslationUser: '业务翻译(给客户)',
    businessSbumit: '业务提出',
    addition: '追 加',
    orderDelete: '删 除',
    productWithTheSameId: '同ID商品',
    sameStoreProduct: '同店铺商品',
    copySelectedProductInformation: '复制选中商品信息',
    copyOrderProductInformation: '复制订单商品信息',
    copyProductInformation: '复制商品信息',
    returnToPurchase: '退给采购',
    procurement: '采购提出',
    replaceTheLink: '替换链接',
    replaceLinkEditing: '替换链接编辑',
    replaceNumber: '替换编号',
    serialNumber: '编号',
    ProductLink: '商品链接',
    makeAnOffer: '提出报价',
    domesticSubtotal: '国内小计',
    internationalSubtotal: '国际小计',
    estimatedShipping: '预估运费',
    customerOrderNotes: '客户订单备注',
    customerOrderRemarkReply: '客户订单备注回复',
    brandMaterial: '品牌材质',
    additionalServiceOptions: '附加服务选项',
    quantity: '数量',
    actualCharges: '实际收费标准',
    estimatedCost: '预计费用',
    indivual: '个',
    total: '合计',
    internationalShippingEstimate: '国际运费预估',
    theTotalArea: '总面积',
    calculate: '计算',
    shippingMethods: '物流方式',
    imageReplacementForm: '图片更换表单',
    upload: '上传',
    productAttributeSelectionForm: '商品属性选择表单',
    addProductForm: '追加商品表单',
    productLink: '商品链接：',
    productSColour: '商品颜色：',
    productSize: '商品尺寸',
    numberOfProducts: '商品数量',
    commodityPrice: '商品单价',
    noProductFoundInTheSameStore: '没有找到同店铺的商品!',
    noProductWithTheSameIdWasFound: '没有找到同ID的商品!',
    whetherToReturnThisOrderToPurchaseForReconfirmation: '是否将此订单回退给采购重新确认?',
    thePeplacementItemCanBeDeletedOnlyWhenItContainsMoreThanOneItem: '替换商品数据大于一项时才可删除',
    pleaseEnterTheProductLink: '请输入商品链接',
    pleaseSelectUploadImage: '请选择上传图片',
    pleaseEnterTheQuantityOfGoods: '请输入商品数量',
    pleaseInputTheUnitPriceOfTheGoods: '请输入商品单价',
    whetherToSubmitProductExchangeLinkInformation: '是否提交商品换购链接信息',
    pleaseEnterTheLinkOfTheItemYouWantToReplace: '请输入要替换的商品链接',
    rollbackCanceled: '已取消回退',
    temporarySave: '临时保存',
    whetherToSaveAttributeSelection: '是否保存属性选择?',
    productAttributesSelectedSuccessfully: '商品属性选择成功!',
    deselected: '已取消选择',
    whetherToSaveTheForm: '是否保存表单?',
    addedProductSuccessfully: '追加商品成功!',
    saveCancelled: '已取消保存',
    whetherToSaveAdditionalServices: '是否保存附加服务?',
    additionalServicesSavedSuccessfully: '附加服务保存成功',
    whetherToSaveImageReplacement: '是否保存图片更换',
    productImageReplacementSuccessfully: '商品图片更换成功!',
    replacementCancelled: '已取消更换',
    whetherToProposeAPurchase: '是否提出采购?',
    purchaseCancelled: '已取消采购',
    whetherToMakeAnOffer: '是否提出报价?',
    offerCancelled: '已取消报价',
    whetherToStartTranslation: '是否开始翻译?',
    translationCancelled: '已取消翻译',
    businessQuotationTime: '业务报价时间',
    financialConfirmationTime: '财务确认时间',
    financeModule: '财务模块',
    whetherToDeleteTheSelectedOrder: '是否删除选中的番?',
    pleaseSelectAtLeastOne: '请至少选中一项!',
    successfullyDeleted: '删除成功！',
    undeleted: '已取消删除',
    confirmUnitPrice: '确认单价',
    return: '返回',
    whetherToReturnToThePreviousPage: '是否返回上一级页面',
    cancelledReturn: '已取消返回',
    customerPaymentTime: '客户付款时间',
    targetLaunchTime: '目标上架时间',
    orderStatus: '订单状态',
    check: '查看',
    orderTime: '订单时间点',
    fulfillmentOrderNotes: '配货订单备注',
    orderSubmission: '订单提出',
    orderTranslation: '订单翻译',
    customerSubmitsRemittance: '客户提交汇款',
    financialConfirmationRemittance: '财务确认汇款',
    theOrderTimePointCorrespondingToTheOrderWasNotFound: '未找到该订单对应的订单时间点',
    noCorrespondingOrderDetailsFound: '未找到相对应的订单详情',
    transactionNumber: '交易号',
    logisticsNumber: '物流号',
    theOrderIsFinished: '订单购买完了',
    inStock: '在库',
    unitPrice: '单价',
    unitPriceRMB: '单价(RMB)',
    unitPriceYen: '单价(日元)',
    unitPrice$: '单价(美元)',
    freight: '运费',
    atTheTimeOfPurchase: '购买时',
    afterFinancialPayment: '财务付款后',
    afterFinancialPaymentNum: '财务付款后数量',
    afterFinancialPaymentKin: '财务付款后金额',
    canBePutIntoStorage: '可入库',
    itHasArrived: '已到货',
    shipped: '已出货',
    beShipped: '待出货',
    salesmanCommodityRemarks: '业务商品备注',
    remarksForPurchasedCommodities: '采购商品备注',
    deliveryProductRemarks: '配货商品备注',
    deliveryNoteNumber: '配送单号',
    internationalLogisticsOrderNumber: '国际物流单号',
    logisticsSingleNumber: '物流单号',
    commoditiesWithTheSameTransactionNumber: '同交易号商品',
    noProductWithTheSameTransactionNumberWasFound: '没有找到同交易号的商品',
    transactionNumberSplit: '交易号拆分',
    transactionNumberModification: '交易号修改',
    logisticsNumberAdded: '物流号添加',
    logisticsNumberModification: '物流号修改',
    logisticsNumberDeleted: '物流号删除',
    pleaseEditTheBrandMaterialFirstAndThenMakeAQuotation: '请先进行品牌材质编辑后再进行报价!',
    closure: '关闭',
    whetherToSubmitTheLogisticsNumberToAdd: '是否提交物流号添加',
    whetherToSubmitTheLogisticsNumberToAdd: '待删除物流号',
    theLogisticsNumberToBeDeleted: '待删除物流号',
    theLogisticsNumberToBeModified: '待修改物流号',
    checkAtMostOne: '至多选中一项',
    whetherToSubmitTheModificationOfTheLogisticsNumber: '是否提交物流号修改',
    noTrackingNumberFound: '没有找到物流单号',
    newLogisticsNumber: '新物流号',
    originalLogisticsNumber: '原物流号',
    modifiedLogisticsNumber: '修改后物流号',
    logisticsNumberToBeDeleted: '待删除物流号',
    whetherToSubmitTheLogisticsNumberToDelete: '是否提交物流号删除',
    pleaseSelectAnOrderWithTheExactSameTransactionNumber: '请选择交易号完全相同的订单',
    quote: '报价',
    timeToTranslate: '翻译完了时间',
    originalTransactionNumber: '原交易号数量',
    remainingAfterSplit: '拆分后剩余',
    numberOfNewTransactionNumbers: '新交易号数量',
    theNumberOfNewTransactionNumbersCannotBeGreaterThanTheNumberOfPreviousTransactionNumbers: '新交易号数量不能大于之前的交易号数量',
    theNewTransactionNumberIsNotFilledIn: '新交易号未填写',
    theNumberOfNewTransactionNumbersIsNotFilledIn: '新交易号数量未填写',
    theNumberOfNewTransactionNumbersMustBeGreaterThan0: '新交易号数量必须大于0',
    whetherToSubmitTransactionNumberSplit: '是否提交交易号拆分',
    transactionNumberAfterModification: '修改后交易号',
    whetherToSubmitTransactionNumberModification: '是否提交交易号修改',
    transactionIdNotFound: '没有找到交易号',
    viewSingleProductTimePoint: '单番商品时间点查看',
    pleaseFillInTheRemarksBeforeSubmitting: '请将备注填写完整后再进行提交',
    whetherToSubmitANote: '是否提交备注',
    userInfo: '客户信息',
    CheckInformation: '信息查看',
    userBill: '客户收支明细',
    bookedTime: '入账时间',
    financialCategory: '账务类别',
    remittanceDetails: '汇款明细',
    purchaseList: '交易号付款',
    searchContent: '搜索内容',
    toBePayment: '待付款',
    payment: '已付款',
    purchaseTime: '采购购买时间',
    financialPaymentPime: '财务付款时间',
    mash: '番号',
    purchaseAccount: '购买账号',
    purchasingData: '采购数据',
    accountsPayable: '应付款',
    customerPayment: '客户付款',
    percentage: '百分比',
    extractingAmount: '抽取金额',
    paymentStatus: '付款状态',
    goodsAmount: '商品金额',
    domesticFreight: '国内运费',
    payments: '付款',
    clientsSun: '客户提现',
    applicationTime: '申请提现时间',
    remittanceTime: '提现汇款时间',
    applicantInformation: '申请人信息',
    applyWithdrawalAmount: '申请提现金额(€)',
    ApplicantsBankAccountInformation: '申请人银行账户信息',
    paymentScreenshots: '支付截图',
    remittance: '汇款',
    cancellationRequest: '取消申请',
    confirmCancellationRequest: '确认后，该提现申请将被取消。需要申请人重新提出申请，请确认',
    pleaseEnterTheLogisticsNumber: '请输入物流号',
    pleaseEnterLogisticsNumberOrBadId: '请输入物流号/不良ID',
    pleaseEnterBadId: '请输入不良ID',
    pleaseEnterTransactionNumber: '请输入交易号',
    theLastFiveDigitsOfTheOrderNumber: '订单号后五位',
    stockNumber: '在库数',
    price: '价格',
    businessCommodityRemarks: '业务商品备注',
    inspect: '核查',
    inspectionOfGoods: '核查检品',
    filter: '筛选',
    editingOfTheRemarksForTheDeliveryProduct: '配货商品备注编辑',
    orderNumberAndCustomerName: '订单号及客户姓名',
    editingOfBusinessProductRemarks: '业务商品备注编辑',
    purchasingCommodityNotesedit: '采购商品备注编辑',
    pleaseEnterTheLogisticsNumberAndTransactionNumberBeforeChecking: '请输入物流号和交易号后再进行核查',
    sameTransactionNumberAndLogisticsNumber: '同交易号物流号',
    addInspectionList: '添加检品单',
    orderNotes: '订单备注',
    printPackageInformation: '打印包裹信息',
    link: '链接',
    copy: '复制',
    numberOfTransactionNumbers: '交易号数量',
    numberOfArrivalsThisTime: '本次到货数',
    theNumberOfItemsThatHaveBeenInspected: '已加检品单数',
    numberOfInspectionProblems: '检品问题数',
    numberOfProblemProducts: '问题产品数',
    inspector: '检品员',
    poorQuantity: '数量差',
    adverseNumber: '不良数',
    inspectionStatus: '检品状态',
    responsibleForRemarks: '担当备注',
    verifierSNotes: '核查员备注',
    askAQuestionAboutTheProduct: '提出问题产品',
    addToInspectionList: '加入检品单',
    markSpecialItems: '标记特殊商品',
    copySuccessfully: '复制成功',
    inspectionStatusDetails: '检品状态详情：',
    inspectionOrderNumber: '检品单号',
    numberToBeChecked: '应检数',
    checkNumber: '实检数',
    submitTheNumberOfBad: '提交不良数',
    submitInspectionTime: '提交检品时间',
    inspectionCompletionTime: '检品完成时间',
    currentState: '当前状态',
    whetherToAddThisProductToTheInspectionList: '是否将该商品加入到检品单中',
    cancelled: '已取消加入',
    whetherToSubmitTheProductForListing: '是否将该商品提交上架',
    numberOfProductsToBeSubmittedForInspection: '待提交检品数',
    numberOfProductsToBeInspected: '应检品数',
    numberOfFbaLabels: 'FBA贴标数',
    labeling: '贴标',
    selectTheSamePackage: '选中同包裹商品',
    removeFromInspectionList: '从检品单移除',
    inspectionListDiscarded: '检品单废弃',
    cancelInspection: '取消检品',
    packageSplit: '包裹拆分',
    inspectionListDeployment: '检品单调配',
    submitForInspection: '提交检品',
    printTheInspectionList: '打印检品单',
    whetherToRemoveTheItemFromTheInspectionList: '是否将该商品从检品单中移除',
    removed: '已取消移除',
    testArticlePersonSelect: '检品员选择',
    allChecked: '全选',
    actualFreight: '实际运费',
    actualPrice: '实际价格',
    sealSpending: '确认报价',
    quotationData: '实时数据',
    generate1688order: '生成1688订单',
    extractTransactionNumberAmount: '抽取交易号金额',
    pendingFinancialPayment: '待财务付款',
    pendingCancellationFinancialPayment: '待财务付款取消',
    questionProduct: '提出问题产品',
    userID: '用户ID',
    thereAreGoodsWaitingToBePaidByFinance: '有商品已经待财务付款，请确认后提交!',
    noTransactionNumberIsEntered: '有商品未填写交易号，请确认后提交',
    submitToFinanceForPayment: '是否确定提交到财务付款？',
    theFinancialDepartmentHasHotYetPaid: '有商品还未待财务付款，请确认后提交',
    returnToTreasurerTorPayment: '是否确定退回到待财务付款?',
    selectableOperational: '请选择要操作的订单',
    selectableOperationalList: '请选择要操作的列表',
    merchandiseToBePhotographed: '待拍下商品',
    couponsSpecified: '优惠券生成(指定客户)',
    voucherPackageManagement: '券包管理',
    stayOut: '待发放',
    ssued: '已发放',
    hasBeenUsed: '已使用',
    batchIssue: '批量发放',
    useTime: '使用时间',
    couponName: '券名称 ',
    couponNameXBY: '券名称(西班牙语) ',
    couponNunber: '券码编号',
    effectiveDate: '有效日期',
    amountEndNumberOfTimesAvailable: '额度/可用次数',
    vouchers: '代金券',
    coupons: '优惠券',
    useRestrictions: '使用限制',
    orderAmount: '订单金额',
    issue: '发放',
    pleaseSelectTheCouponToBeIssued: '请选择要放发的优惠券',
    issueCoupons: '确认是否发放该优惠券吗？',
    clientList: '客户列表',
    removeAll: '全部清除',
    selectCustomerGeneration: '选中客户生成',
    couponTemplate: '优惠券模板',
    templateManagement: '模板管理 ',
    number: '数量',
    couponsWhetherGeneratedImmediately: '请核对优惠券列表，是否立即生成？',
    inputCouponName: '请输入优惠券名称',
    inputCategorye: '请选择类别',
    TheCustomerSpecifiesTheModeOfTransportation: '客户指定运输方式', //客户指定运输方式
    totalVolume: '合计体积', //合计体积
    EstimatedInternationalFreightEUR: '预估国际运费EUR', //预估国际运费EUR
    SpainIsExpectedToDomesticDeliveryCosts: '预计西班牙国内派送费', //预计西班牙国内派送费
    AntidumpingDutyExpected: '预计反倾销税', //预计反倾销税
    ExpectedvalueAddedTax: '预计增值税', //预计增值税
    inputAmountEndNumberOfTimesAvailable: '请输入额度/可用次数',
    inputUseRestrictions: '请输入使用限制',
    allGoods: '全部商品',
    toBePhotographed: '等待拍下',
    TheGoodsWithTheArrivalNumberOf0AreNotSupportedToBePutOnShelves: '本次到货数为0的商品不支持上架',
    TheNumberOfGoodsDeliveredThisTimeCannotBeGreaterThanTheNumberOfPossibleShelvesWhichIsCurrently: '本次到货数不能大于上架可能数,当前上架可能数为',
    attention: '注意',
    ThereAreGoodsCorrespondingToTheDistributorIsNotTheCurrentLoggedInDistributorPleaseConfirmBeforeOperation: '有商品对应配货员不是当前登录配货员！请确认后再操作',
    whetherToCancelTheInspectionOfTheProduct: '是否取消该检品单',
    whetherToDiscardTheInspectionList: '是否废弃该检品单',
    Abandoned: '已取消废弃',
    onlyOneLogisticsNumberIsSupported: '暂只支持单个物流号',
    thereIsNoLogisticsNumberForThisProduct: '该商品没有物流号',
    ICouldntFindTheSamePackage: '没有找到同包裹的商品',
    pleaseSelectTheInspectorBeforeSubmitting: '请选中检品员后再进行提交',
    whetherToAssignTheInspectorToTheDeliveryOrder: '是否将该检品员调配至配送单',
    deploymentCancelled: '已取消调配',
    numberOfRemainingProductsToBeInspected: '剩余应检品数',
    numberOfNewInspectionOrders: '新检品单数量',
    TheNumberOfNewInspectionListShouldNotBeLargerThanTheNumberOfPreviousInspectionItems: '新检品单数量不能大于之前的应检品数',
    TheNumberOfNewInspectionOrdersShouldNotBeLessThanOrEqualTo0: '新检品单数量不能小于等于0',
    confirmTheSplit: '确认拆分',
    pleaseFillInTheNumberOfNewInspectionOrderBeforeSubmission: '请填写新检品单数量后再进行提交',
    whetherToSubmitPackageUnpacking: '是否提交包裹拆分',
    whetherToSubmitTheInspectionList: '是否提交该检品单',
    waitingForGoods: '待检品',
    testArticle: '检品',
    timeOfInspectionListSubmission: '检品单提出时间',
    inspectionFinishedTime: '检品完了时间',
    remarksOnInspectionList: '检品单备注',
    inspectionListStatus: '检品单状态',
    listOfGoods: '检品列表',
    badSummary: '不良汇总',
    badInspection: '不良核查',
    badMarkCode: '不良码',
    pleaseEnterBadMarkCode: '请输入不良码',
    badMarkCodeNotFound: '未查询到该不良码',
    problemState: '问题状态',
    problemConfirmed: '问题已确认',
    isProblemConfirmed: '是否问题已确认？',
    CheckList: '检品单',
    numberOfAdditionalServicesToBeProcessed: '待处理附加服务数量',
    itHasBeenConfirmedWhetherTheStatusOfTheItemHasBeenChangedToPoor: '是否将该商品状态变成不良已确认',
    theStatusModificationHasBeenCancelled: '已取消状态修改',
    pleaseFillInTheTransactionNumberOrLogisticsNumber: '请填写交易号或物流号',
    whetherToStartProcessingTheInspectionList: '是否开始处理该检品单',
    theActualNumberOfInspectionShouldNotBeGreaterThanTheQuantityOfInspection: '实检数不能大于应检品数',
    theNumberOfActualChecksCannotBeLessThan0: '实检数不能小于0',
    theNumberOfDefectsShouldNoBeGreaterThanTheNumberOfShouldBeInspected: '不良数不能大于应检品数',
    theNegativeNumberCannotBeGreaterThanTheActualNumber: '不良数不能大于实检数',
    theNegativeNumberCannotBeLessThan0: '不良数不能小于0',
    finishedGoods: '检品完了',
    whetherToKeepTheInspectionListTemporarily: '是否临时保存该检品单',
    theTemporarySaveHasBeenCancelled: '已取消临时保存',
    pleaseFirstChangeTheInspectionListStatusToStartProcessing: '请先将检品单状态改为开始处理',
    theParcelInformation: '包裹信息',
    toBeOn: '需上架',
    printTime: '打印时间',
    print: '打印',
    commodityNote: '商品备注',
    storesUp: '上架完了',
    awaitTranslated: '待翻译',
    toReply: '待客户回复 ',
    userReply: '客户回复 ',
    businessToProcessed: '待业务决策',
    businessDecisions: '业务决策',
    businessDecisionsRemark: '业务决策备注',
    purchaseToProcessed: '待采购处理',
    procurementProcess: '采购处理',
    procurementProcessRemark: '采购处理备注',
    distributionToProcessed: '待配货处理',
    distributionProcessed: '配货确认',
    accomplish: '已完成',
    problemPic: '问题图片',
    problemNunber: '问题产品数',
    problemDescription: '具体问题描述',
    problemProductProposal: '问题产品提出',
    hasBeenShipped: '已出货',
    problemStatus: '问题状态 ',
    newAdditionalServices: '修改后附加服务',
    editAdditionalServices: '修改附加服务',
    problemPropose: '问题提出',
    poundage: '手续费',
    additionalServiceCharge: '附加服务费',
    editNumber: '修改后数量',
    editPrice: '修改后单价',
    editFreight: '修改后运费',
    procurementProcessRemark: '采购处理备注',
    confirmPayment: '确认付款？',
    porder: '配送单',
    underwayPorder: '进行中的配送单',
    toEncasement: '待装箱',
    encasement: '装箱',
    encasementStatus: '装箱状态',
    toQuote: '待报价',
    toPayment: '待支付',
    financialConfirmationCoTheAccount: '财务确认到账',
    businessShip: '业务出货',
    signFor: '签收',
    porderNumber: '配送单号',
    porderStatus: '配送单状态',
    porderSubmit: '配送单提交',
    porderTranslate: '配送单翻译',
    porderEncasement: '配送单装箱',
    porderQuote: '配送单报价',
    EuropeSignFor: '欧洲签收',
    userSignFor: '客户签收',
    porderProperty: '配送单属性',
    userSpecificMode: '客户指定方式',
    businessPorderRemark: '业务配送单备注',
    distributionPorderRemark: '配货配送单备注',
    porderRemark: '配送单备注',
    quotationDate: '报价完了',
    company: '公司名',
    zip_code: '邮编',
    address: '地址',
    contacts: '联系人',
    mobile: '手机号',
    tel: '电话',
    email: '电子邮箱',
    orderMash: '订单番号',
    boxed: '已装箱',
    putForwardNum: '提出数',
    forGoods: '商品费用',
    subtotal: '小计',
    warehouseNumber: '仓库数量',
    quantityOfGoodsUsedInStock: '库存商品使用数量',
    warehouse: '仓库',
    packingCase: '装箱情况',
    finishPacking: '装箱完了',
    finishPackingCancel: '装箱完了取消',
    totalWeights: '合计重量',
    wayToSend: '发送方式',
    modeOfDespatch: '发货方式',
    addBox: '添加箱子',
    delBox: '删除箱子',
    editBox: '修改箱规毛重',
    printPackingList: '打印装箱单(有单价)',
    printingMarks: '打印唛头',
    submissionToBusiness: '提交给业务',
    isSubmissionToBusiness: '确认提交给业务？',
    importer: '进口商信息',
    receive: '收件人信息',
    customerDeliveryNotes: '客户配送单备注',
    customerDeliveryNotesTranslation: '客户配送单备注翻译',
    otherFees: '其他费用',
    otherFeesEdit: '其他费用编辑',
    otherFeesRemark: '其他费用备注',
    tariffs: '关税',
    estimateInternationalCosts: '预估国际费用',
    customerDesignatedShippingCompany: '客户指定运公司',
    customsClearanceWay: '通关方式',
    nowRate: '今日汇率',
    internationalFees: '国际费用',
    boxNumber: '箱子数',
    boxRoughWeight: '箱子毛重',
    boxPile: '箱型',
    length: '长',
    width: '宽',
    height: '高',
    boxDetail: '箱子详情',
    freightNum: '本箱已装箱数',
    otherBoxNum: '其他已装箱数',
    movingGoodsBox: '商品移箱 ',
    movingGoodsNum: '移箱数',
    quantityOfGoodsUsedInStock: '库存商品数',
    okEncasement: '确定装箱?',
    isEncasementCancel: '确定取消装箱完了?',
    submitDeliverer: '提交给配货员',
    isSubmitDeliverer: '确认提交给配货员？',
    returnDelivery: '退回给配货',
    isReturnDelivery: '确认退回给配货？',
    returnToBeQuoted: '退回待报价',
    isReturnToBeQuoted: '确认退回待报价？',
    backToNotPay: '退回待入金',
    isBackToNotPay: '确认退回待入金？',
    quotationCustomer: '给客户报价',
    isQuotationCustomer: '确认给客户报价？',
    presentBoxNum: '当前箱号',
    personalCustomsClearance: '个人通关',
    personalCustomsCompany: '代通关',
    encasementInterface: '装箱界面',
    selectBoxNum: '当前选中箱数 ',
    selectBoxes: '选中箱号',
    oneCasePack: '每一箱装箱数',
    boxNum: '箱数',
    internationalDeliveryInformation: '国际派送信息',
    loadingTime: '装柜完了时间',
    loading: '装柜完了',
    isLoading: '确认装柜完了？',
    dateOfShipment: '货运出货日期  ',
    feedbackTime: '提单反馈时间  ',
    customsTlearanceTime: '通关时间  ',
    spainTheDeliverTime: '西班牙发货时间',
    deliveryTime: '发货时间',
    spainSendsMessages: '西班牙派送信息 ',
    spainSendsMessagesEdit: '西班牙派送信息编辑',
    domesticDeliveryCostsInSpain: '西班牙国内派送费用',
    forBooking: '待订舱 ',
    haveBooking: '已订舱待回复 ',
    theContainer: '待装柜 ',
    shippedOut: '出货完了',
    booking: '订舱 ',
    packingListInvoice: '箱单发票',
    setTheTank: '定舱',
    destination: '目的地 ',
    bookingVolume: '订舱体积m3',
    deliveryOrder: '配送单出货',
    containerCancel: '取消订舱',
    cabinetCancel: '取消装柜',
    isContainerCancel: '确认取消订舱？',
    iscontainerCompleteBack: '确认取消装柜完了？',
    positionOk: '船位已确定',
    BookingTime: '订舱时间',
    destinationPor: '目的港',
    theBillOfLadingToUpload: '提单上传',
    theBillOfLadingToDownload: '提单下载',
    theBillOfLadingToDocuments: '提单文件',
    packingListInvoiceDownload: '箱单发票下载',
    invoice: '发票',
    delivery: '派送中',
    internationalDeliveryIsUnderway: '国际派送中',
    haveCustomsClearance: '已通关',
    isHaveCustomsClearance: '确认整个单号的配送单都将通关完了？',
    daiQianShou: '待客户签收',
    spanishDelivery: '西班牙派送',
    SpanishLogistics: '西班牙物流号',
    received: '已签收',
    thisCaseNum: '本箱装箱数',
    moveFreightGoods: '确认移箱',
    moveTheBoxNumber: '需移到选中箱子的商品数',
    selectTheSendingMode: '选择发送方式',
    guiLei1688: '1688归类',
    currentBalance: '当前余额:',
    mentionOrder: '提订单',
    mentionDistribution: '提配送单:',
    orderPaymentAuthorization: '订单入金授权:',
    distributionPaymentAuthorization: '配送单入金授权:',
    customerMarks: ' 客户唛头:',
    unauthorized: '未授权',
    haveAuthorized: '已授权',
    authorized: '授权',
    noAuthorized: '不授权',
    chatTools: '聊天工具:',
    customerRelatedOperationFunctions: '客户相关操作功能 ',
    customerAttributeIdentification: '客户属性标识',
    customerProperty: '客户属性',
    customerShippingMarkSetting: '客户唛头设置',
    chatSettings: '聊天工具设置 ',
    authorizationSettings: '授权设置',
    deliveryToEntrust: '发货委托 ',
    allOrder: '全部订单',
    quotedPrices: '报价中',
    waitingPayment: '等待付款',
    problemOfGoods: '问题商品',
    freightQuoted: '运费报价中',
    freightToBePaid: '运费待付款 ',
    index: '首页',
    orderManagement: '订单管理',
    deliveryOrderBeforeShipment: '出货前配送单 ',
    internationalTransport: '国际运输中',
    moneyManagement: '资金管理 ',
    entryAndExitDetails: '出入金明细',
    afterSaleConfirmationMethod: '请选择售后确认方式',
    completeDirectly: '直接完成',
    directCompleteDescription: '说明',
    directCompleteDescriptionPlaceholder: '请输入直接完成说明',
    directCompleteProof: '凭证',
    uploadProof: '上传凭证',
    directCompleteRequirement: '说明和凭证任选其一必填，凭证最多上传8个文件，文件类型与大小不限。',
    directCompleteRequired: '请填写说明或上传凭证',
    directCompleteProofLimit: '凭证最多上传8个文件',
    proofUploadFailed: '凭证上传失败，请重试',
    entryAndExitPreview: '出入金预览',
    customerInternalManagement: '客户内部管理',
    notesForCustomers: '客户注意事项 ',
    mattersNeedingAttention: '注意事项 ',
    wuliuMattersNeedingAttention: '1、区间表示大于左边,小于等于右边 结束值不填默认为上限无穷大',
    IsBuying: '正在购买',
    canceled: '已取消',
    proposedDate: '提出日期',
    paymentDate: '付款日期',
    purchaseCompletionDate: '购买完了日期',
    remark: '备注',
    product: '产品',
    shop: '店铺',
    totalPrice: '总价',
    commodityTotalPrice: '商品总价值',
    putForward: '提出',
    addCommodity: '追加商品',
    numberTotabl: '数量总计',
    items: '商品种类',
    allExpenses: '全部的费用',
    productValue: '产品价值',
    chooseAnInternationalCarrier: '选择国际运输公司',
    balancePayment: '余额支付',
    estimatedOrderAmount: '预计订单金额',
    useOoupons: '使用优惠券',
    accountBalanceAfterPayment: '付款后账户剩余',
    actualAmountPaid: '实际支付金额',
    pay: '支付',
    paySuccess: '支付成功',
    paymentRransactionNumber: '付款交易号',
    returnListInterface: '返回列表界面',
    putForwardDeliveryOrder: '提出配送单',
    canBePutForward: '可提出',
    thePacking: '装箱中',
    quantityAvailableForDelivery: '可提货数量',
    quantityAvailableDelivery: '提货数量',
    priceYuan: '单价(元)',
    purchaseQuantity: '购入数量',
    rakumartPersonalCustomsCompany: 'rakumart代通关',
    appendDeliverylist: '追加到配送单',
    allDelivery: '全部配送单',
    BillingWeight: '计费重量(kg)',
    InternationalLogisticsFee: '国际物流费用(€)',
    hasHeenShipped: '已发货',
    toHeenShipped: '待发货',
    isPorderBalancePayment: '确认给配送单付款？',
    haveSustomsClearance: '已清关',
    SpanishDeliveryInProgress: '西班牙派送中',
    clientReceive: '签收',
    isClientReceive: '确认签收配送单？',
    keyword: '关键词',
    transactionType: '交易类型',
    transactionWay: '交易方式',
    financialConfirmationDate: '日期(财务确认日期)',
    time: '日期',
    theDetail: '明细',
    amountChange: '金额变动',
    parcelSearch: '包裹搜索',
    courierNumber: '快递单号 ',
    entry: '录入 ',
    packageScanning: '包裹扫描',
    signer: '收件',
    noAccountPayable: '应付款不能小于0',
    NoUser: '未匹配到相对应的id的客户',
    danGeDanDingDan: '问题产品提出需要限制单次只能单个订单的商品一起提出问题产品',
    cancelAllChecked: '取消全选',
    problemStoreEooro: '存在待财务付款状态的商品，不能提出问题产品。请取消待财务付款后在提问题产品',
    EstimatedTotalVolumeOfGoods: '预计商品总体积',
    EstimatedWeight: '预计重量',
    AntiDumpingDuties: '反倾销税',
    TheVAT: '增值税',
    Problem: '问题产品',
    preSaleProblem: '售后问题',
    adjust: '出入金',
    adjustList: '出入金列表',
    submitTime: '提交时间',
    adjustReason: '内部调整原因 ',
    categorySelection: '类别选择 ',
    notesForCustomersToSee: '给客户看的备注(西班牙文)',
    customerScreenshots: '客户联系截图',
    adjustTheType: '调整类型',
    specificCauseRemarks: '具体原因备注',
    PackingVolume: '装箱体积',
    relatedTransactionNumber: '关联交易号 ',
    packageSearchForm: '包裹搜索表单',
    domesticReturn: '国内退件',
    signForMember: '签收员',
    logisticsFollow: '物流货运跟进',
    offline_wait: '待线下提货',
    addOfflinePickup: '添加线下提货',
    registrationTime: '登记时间',
    peoplePutForward: '提出人',
    jianShu: '件数',
    RMBfreightCost: '运费.元',
    pickUpContactInformation: '提货联系人信息',
    AddressRemarks: '地址、备注',
    deliveryContact: '提货联系人',
    deliveryContactPhone: '提货联系人电话',
    TheRequired: '此项为必填项',
    theGoods: '收货',
    receivingEndOfaSingle: '收货底单',
    transferRecord: '转账记录',
    goodsTakenForConfirmation: '已提货待确认',
    deliveryConfirm: '提货已确认',
    goodsTime: '收货时间',
    returnForPickup: '退回待提货',
    confirmBackReturnForPickup: '确认退回待提货？',
    submitOne: '提交人',
    expressNo: '快递号',
    signForPeople: '签收人',
    urgent: '紧急件',
    pendienteDeFirma: '待签收',
    noticeList: '通知列表',
    notice: '通知',
    title: '标题',
    content: '内容',
    sendTime: '发送日期',
    alerts: '发布通告',
    noticeGroup: '通告群体',
    Announcements: '通知公告',
    personnelSelection: '人员选择',
    noticeContent: '通知内容',
    noticeTitle: '通知标题',
    noticeLook: '通知预览',
    preview: '预览',
    areYouSureToNotice: '请再次确认是否发送通知，通知一经发送无法取消',
    adminNoticeList: '通知列表',
    noticeDelete: "当前选择的通知中，包含有未读的通知，是否确认删除选中的内容。",
    directBusinessCompletion: '业务直接完成',
    confirmdirectBusinessCompletion: '确认业务直接完成?',
    backlog: '待修改',
    modified: '已修改',
    BulkChanges: '批量修改',
    BatchConfirmation: '批量确认',
    GoogleAutomaticallyTranslatesTheResults: '谷歌自动翻译结果',
    ManuallyModifyKeywords: '人工修改关键词',
    SearchResultsInterface: '搜索结果界面',
    look: '查看',
    lookDetail: '查看详情',
    editName: '修改人',
    editTime: '修改时间',
    SearchKeywordModification: '搜索关键词修改',
    ProductSpecificationsKeywordMaintenance: '商品规格关键词维护',
    ManualSearchKeywordMaintenance: '商品属性翻译维护',
    KeywordMaintenance: '关键词翻译维护',
    WordsEnteredByTheCustomer: '客户输入的词',
    ArtificialKeywordsBatchModification: '人工关键词批量修改',
    Modificaçãomanualdepropriedadesespanholas: '人工修改西班牙语属性',
    ToFindTheContent: '查找内容',
    AlternativeContent: '替换内容',
    confirm: '确认',
    FillChineseValues: '填充中文值',
    FillTranslationValue: '填充翻译值',
    goodsQualityCacheClear: '清除商品缓存',
    isGoodsQualityCacheClear: '请确保本次批量修改已全部完成，缓存清除后客户首次打开商品界面会很慢，谨慎作此操作',
    web_img: 'pc版主图',
    default_back_color: '默认背景颜色',
    trigger_back_color: '触发时背景颜色',
    orderSubmissionTime: '订单提交时间',
    orderType: '订单类别',
    originalOrder: '原订单',
    amountOfOrderYuan: '订单金额.元',
    orderPropertyEditing: '订单属性编辑',
    orderRemarksEditing: '订单备注编辑',
    orderAdjust: '订单调整',
    transactionNumberStatus: '交易号状态',
    financialPaymentIsUrgent: '待财务付款紧急',
    waitingForChangePrice: '等待改价',
    orderInformation: '订单信息',
    currentOrderInformation: '当前订单信息',
    deleted: '已删除',
    customerOrdersCommodityAttributes: '客户下单商品属性',
    userNum: '客户数量',
    userOriginalPrice: '客户原价',
    businessEditAttributes: '业务编辑属性',
    confirmPurchasePrice: '实际采购价',
    singleItemSize: '单个商品尺寸.cm',
    individualWeight: '单个重量.kg',
    tagNumber: '标签编号',
    tagOperation: '标签操作',
    codeCopyToText: '编码复制到文本',
    addMadeInChina: '新增Made in China',
    orderLastFour: '订单号后四位',
    orderLastFourAddFailed: '订单号后四位添加失败',
    batchModifyBarcodeFormat: '批量修改条码格式',
    orderTagDeleteUnavailable: '订单标签删除接口暂未提供',
    orderTagDeleteSuccess: '标签删除成功',
    orderTagDeleteFailed: '标签删除失败',
    madeInChinaAddFailed: 'Made in China 添加失败',
    clearMatchDataFailed: '清空匹配数据失败',
    batchModifyCodeTypeFailed: '批量修改条码格式失败',
    codeCopyToTextFailed: '编码复制到文本失败',
    tagMatchingFailed: '标签匹配失败',
    orderTagPrintFailed: '标签打印状态更新失败',
    orderTagPrintReasonFailed: '打印原因登记失败',
    quoteInLibraryNumber: '报价在库数',
    productSpecifications: '商品规格',
    alternative: '备选',
    size: '尺寸',
    weight: '重量',
    commodityMonitoringEntry: '商品监控录入',
    obtainStoreInformation: '获取店铺信息',
    additional: '追加',
    customersAddAttachments: '客户添加附件',
    propertyEditForm: '属性编辑表单',
    websitePropertySelection: '网站属性选择',
    manuallyEditProperties: '人工编辑属性',
    attributeName: '属性名称',
    specificAttributeValue: '具体属性值',
    regularOrders: '普通订单',
    forwardOrders: '转寄订单',
    takeSampleOrders: '拿样订单',
    AccessorieOrder: '辅料订单',
    additionalServiceOptions: '附加服务选择',
    internationalFreightEstimate: '国际运费预估',
    totalVolumes: '总体积',
    totalWeight: '总重量',
    orderTypeEditing: '订单类型编辑',
    surveyOfFreight: '调查运费',
    LogisticsAdditionalServiceMaintenance: '附加服务维护',
    sortNumberSetting: '排序编号设置',
    accountingRules: '计费规则',
    defaultChargeRate: '默认收费标准',
    problemProductsAreAutomaticallyCalculated: '问题产品自动计算',
    systemNumber: '系统编号',
    optionNnitPriceQuantity: 'option单价*数量 ',
    unitpriceofgoodsPercentage: '商品单价*百分比 ',
    automaticCalculation: '自动计算',
    artificialCalculation: '人工计算',
    noAutomaticCalculation: '不自动计算',
    units: '单位',
    internationalLogisticsMaintenance: '国际物流维护',
    activeElementSettingsInRealTime: '实时生效元素设置',
    theLogisticsTrackingNumberIsAutomaticallyObtained: '物流单号自动获取',
    customerOrderSelectionPrompt: '客户订单选择提示',
    setThemRoughly: '号段设置',
    promptMessageSetting: '提示语设置',
    addedManualQuotationRules: '新增人工报价规则',
    editdManualQuotationRules: '编辑人工报价规则',
    addedAutomaticQuotationRule: '新增自动报价规则',
    editAutomaticQuotationRule: '编辑自动报价规则',
    daysOfAutomaticReceipt: '自动签收天数',
    takeTheWholeRange: '取整区间',
    priceRange: '价格区间',
    thatSet: '说明设置',
    japaneseDescriptionSettings: '日文说明设置',
    EnglishDescriptionSettings: '中文说明设置',
    setTheLogisticsTrackingNumberAutomatically: '物流单号自动获取设置',
    themRoughlyRules: '号段规则',
    availableQuantity: '可用数量',
    prefix: '前缀',
    startSingleNumber: '开始单号',
    singleNumber: '截止单号',
    promptMessageSetting: '提示语设置',
    effectiveDate: '生效日期',
    billingWay: '计费方式',
    singleTransmissionMode: '单发送方式',
    accumulatesAfterChargingForASingleBox: '单箱计费后累加',
    valuationType: '计价类型',
    meterBehindWay: '计抛方式',
    takeTheWholeOrder: '取整顺序',
    takeTheFirst: '先取整',
    afterTheWhole: '后取整',
    singleBox: '单箱',
    theTicket: '整票',
    castHeavyProportion: '抛重比例',
    whetherToCountHalfCast: '是否计半抛',
    TheWeightVolumeIsRounded: '重量/体积取整区间',
    pricingInterval: '计价区间',
    additionalCharge: '额外收费',
    whetherToReturnToGold: '是否回退待入金?',
    directPayments: '直接付款',
    whetherToConfirmDirectPayment: '是否确定直接付款？',
    generatingTaobaoOrders: '生成淘宝订单',
    markThePriceToBeChanged: '标记待改价',
    theStatusIsWrongPleaseRefreshAndTryAgain: '状态有误, 请刷新重试!',
    customerAfterPaymentQuantity: '客户付款后数量',
    customerAfterPaymentOrder: '客户付款后订单',
    customerAfterPaymentPrice: '客户付款后价格',
    transactionNumberLogisticsNumber: '交易号/物流号',
    customerOrderDetails: '客户下单详情',
    originalTransactionNumber: '原交易号',
    numberOfOriginalTransactionNumbers: '原交易号数量',
    newTransactionNumber: '新交易号',
    numberOfNewTransactionNumbers: '新交易号数量',
    residualAfterSplit: '拆分后剩余',
    productDescriptionInChineses: '中文商品描述',
    defaultInformationSource: '默认信息来源',
    domesticReturnScan: '国内退件扫描',
    scanningParcel: '包裹扫描',
    followUpTheReplacementPackage: '换货包裹跟进',
    returnAndExchangeLogistics: '退换货物流跟进',
    printFaceSheet: '待打印面单',
    SignInScan: '签收已扫描',
    returnScan: '退件待扫描',
    toBePacked: '退换货记录',
    toBePackedStatus: '待打包',
    packingStatus: '打包状态',
    returnAndExchangeNumber: '退换货编号',
    typeOfReturnOrExchange: '退换货类别',
    quantityOfReturnAndReplacement: '退换货数量',
    detailsOfGoods: '商品明细',
    returnAndExchangeLogisticsNumber: '退换货物流号',
    refundLogisticsNumber: '退件物流号',
    packedUp: '已打包',
    pack: '打包',
    possibleNumberOfShelves: '上架可能数',
    claimAParcel: '待认领包裹',
    haveBeenClaimed: '已认领包裹',
    site: '站点',
    personOfRegistration: '登记人',
    pictureOfPackage: '包裹图片',
    toClaim: '认领',
    packageAddition: '包裹新增',
    packageEdit: '包裹编辑',
    personOfClaim: '认领人',
    returnToBeClaimed: '退回待认领',
    printTheShippingMark: '打印包裹唛头',
    signAndNoteThePicture: '签收备注图片',
    remarksOfSigner: '签收员备注',
    emergencyItems: '紧急件',
    remarksOfProposer: '提出人备注',
    urgentItemsAdded: '紧急件新增',
    returnAndExchangeEditor: '退换货编辑器',
    typeOfReturnOrExchange: '退换货类别',
    checkCommodityFollowUp: '核查商品跟进',
    wholeRoundQuantity: '整番数量',
    numberOfTransactionNumbers: '交易号数量',
    underCheck: '核查中',
    onTheShelf: '上架中',
    last5DigitsOfTheOrderNumber: '订单号后5位',
    putOnStoreShelves: '上架入库',
    directPacking: '直接装箱',
    addTheGeneralInspectionList: '添加普检单',
    addTheQualityCheckSheet: '添加精检单',
    startChecking: '开始核查',
    printCustomerInformation: '打印客户信息',
    theCurrentOrderIsInBox: '当前订单装箱中',
    theCurrentOrderHasBeenBoxed: '当前订单已装箱',
    otherOrdersAreInBoxes: '其他订单装箱中',
    otherOrdersHaveBeenBoxed: '其他订单已装箱',
    addNewChest: '添加新箱子',
    boxGaugeModification: '箱规修改',
    modificationOfWeigh: '重量修改',
    cancellationOfPacking: '取消已装箱',
    markPackingFinished: '标记装箱完了',
    numberOfBoxes: '箱子数量',
    aBoxWithNoSelectedOperation: '未选择操作的箱子',
    areYouSureTheMarksArePackedProperly: '是否确定标记装箱完了？',
    areYouSureToReturnAfterPacking: '是否确定装箱完了回退？',
    putForwardTheQuantityToBePacked: '提出待装箱数量',
    remainingNumberToBePacked: '剩余待装箱数',
    boxNO: '箱号',
    quantityOfCargoInThisCase: '本箱装货数',
    priceY: '价格.元',
    cancelTheBox: '取消箱子',
    takeOutGoods: '取出商品',
    whetherToTakeOutTheGoods: '是否取出商品？',
    saveThePackingListInformation: '保存装箱单信息',
    weightFillingBar: '重量填写栏',
    boxRemarks: '箱子备注',
    boxRemarksEdit: '箱子备注编辑',
    temporaryStorageLocation: '临时库位',
    goodsNeedToBeMoved: '需要移箱商品',
    confirmationOfBoxMoving: '确认移箱',
    numberOfOtherBoxesPacked: '其他箱已装箱数',
    abandonedGoods: '废弃商品申请',
    cleanUpGoods: '清理商品',
    warehouseLocationManagement: '库位管理',
    areaSettings: '区域设置',
    inventoryDetails: '库存详情',
    allAreas: '全部区域',
    inUse: '使用中',
    disable: '停用',
    areaNumber: '区域编号',
    regionalUsageSetting: '区域用途设置',
    building: '楼栋',
    element: '站点',
    floor: '楼层',
    areaSizeM: '区域尺寸(米)',
    regionalUse: '区域用途',
    numberOfAreaDatabaseLocations: '区域库位个数',
    areaDescription: '区域描述',
    statusOfUse: '使用状态',
    buildingWhereTheRegionIsLocated: '区域所在楼栋：',
    unitOfTheRegion: '站点：',
    floorOfTheArea: '区域所在楼层：',
    subdivisionAreaUse: '细分区域用途',
    regionalUsageCode: '区域用途编码',
    regionalUsageCodeTip: '区域用途设置新增区域编码打印展示，后续会经常修改',
    addType: '添加类别',
    inAreaNumber: '所在区域编号',
    categoryOfShelves: '货架类别',
    shelfSizeMeters: ' 货架尺寸.米',
    shelfLayerNumber: '货架层数',
    numberOfLibraryBitsPerLayer: '每层库位数',
    shelfNumber: '货架编号',
    rangeOfUseOfShelf: '货架使用范围',
    managementPersonnel: '管理人员',
    remarksOnShelves: '货架备注',
    batchOpen: '批量开启',
    batchClose: '批量关闭',
    batchCreateSystemShelf: '批量创建系统货架',
    createShelfCount: '创建货架个数',
    creating: '正在创建',
    setShelfUser: '设置货架使用人',
    batchSetShelfUser: '批量设置货架使用人',
    userAttribute: '使用人属性',
    specificRange: '具体范围',
    shelfUserRangeTip: '设置货架使用人，只能修改货架的使用人属性以及具体范围。属性为公共货架时范围展示组织，属性为个人货架时范围展示人员。具体范围只展示当前账号层级下的组织与人员。',
    owningRegion: '所属区域',
    scopeOfUse: '使用范围',
    publicShelf: '公共货架',
    personalShelf: '个人货架',
    specificPersonnel: '全体人员',
    typeOfProblem: '问题类别',
    problemSolving: '问题处理',
    pre_saleProblem: '售前问题',
    amountAfterGol: '入金后数量',
    amountAfterGol: '入金后数量',
    generalGoodsWarehouse: '常规商品仓库',
    sparePartsWarehouse: '备品仓库',
    auxiliaryMaterialsWarehouse: '辅料仓库',
    chargeWarehouse: '收费仓库',
    inAbout30Days: '近30天上架完',
    itWentOnTheShelves30DaysAgo: '30天前上架完',
    goodsID: '商品ID',
    timeOfPayment: '入金时间',
    timeType: '时间类型',
    petitionForAbandonment: '申请废弃',
    moveTheLibrary: '移库',
    export: '导出',
    remove: '清除',
    isRemove: '是否清除选中的商品？',
    returnTheBoxedList: '退回已装箱列表',
    location: '库位',
    remarksOfSubdivisionRegion: '细分区域备注',
    timeOfStorage: '入库时间',
    outOfShelfTime: '上架完了时间',
    timeOfPackingFinished: '装箱完了时间',
    numberOfLibraryPositions: '库位数',
    orderOperato: '订单操作人员',
    boxGauge: '箱规(cm)',
    serviceBoxRemarks: '业务箱子备注',
    daysOfCharging: '计费天数',
    expensesIncurred: ' 已产生费用(元)',
    wasteGoods: '商品废弃',
    packingInformation: '装箱信息',
    attributeOfAuthorization: '授权属性',
    type: '类型',
    numberOfStorageLocations: '库位数量',
    quantityOfWaste: '废弃数量',
    actualQuantityOfSparePart: '实有备品数量',
    contactScreenshot: '联系截图',
    remarksOnReasonsForTransfer: '转入原因备注',
    pendingApprova: '待审批',
    approvedAndApproved: '已审批',
    Deleted: '已删除',
    serviceRemarks: '业务备注',
    distributionRemarks: '配货备注',
    personalArea: '个人区域',
    commonArea: '公共区域',
    warehouseGoods: '库位商品',
    numberOfInventory: '库存数',
    theApplicant: '申请人',
    times: '时间',
    applicationReasonRemarks: '申请原因备注',
    numberOfLibraryPosition: '库位数',
    numberOfWaste: '废弃数',
    numberOfActualNumbers: '实有数',
    isTheApprovalConfirmed: '确定审批通过？',
    cleanUpTime: '清理时间',
    quantityOfClearance: '清理数量',
    theCleaner: '清理人',
    packingTimeDB: '打包时间',
    quantityOfWarehouseTransfer: '移库数量',
    whetherToConfirmThePackage: '是否确认打包?',
    entryOfLogisticsBillNumber: '物流单号录入',
    returnToPrint: '退回待打印',
    isReturnToPrint: '是否确定退回待打印？',
    returnScanTime: '退件扫描时间',
    editTheReturnNumber: '返件单号编辑',
    returnNumber: '返件单号',
    returnTrackingNumber_Status: '返件单号-状态',
    addTheReturnTrackingNumber: '添加返件单号',
    addReplacementReturnTrackingNumber: '添加换货返件单号',
    returnAndExchangeFollowUp: '退换货跟进',
    waitForTheSellerToReturnTheGoods: '等待卖家返件',
    replacementPackageToBeSigned: '换货包裹待签收',
    theReplacementPackageHasBeenReceived: '换货包裹已签收',
    theReplacementIsCancelled: '取消换货',
    isTheReplacementIsCancelled: '是否确定换货取消？',
    summaryOfBadPerformanc: '不良汇总',
    problemToBeConfirmed: '检品完了待确认不良',
    theTemporaryInspectionIsDefective: '临时检品待确认不良',
    theBusinessEditsTheCommodityProperties: '业务编辑商品属性',
    numberOfGeneralTestprecisionTestProblems: '普检/精检问题数',
    numberOfLabelLayoutProblems: '布标问题数',
    finalQuantity: '最终数量',
    finalUnitPrice: '最终单价',
    finalFreightRate: '最终运费',
    whetherPerformanceNeedsToBeCalculated: '是否需要计算绩效',
    generalInspectionReinspectionList: '普检复检单',
    fineRetestList: '精检复检单',
    numberOfGoodsToBeReinspected: '需复检商品数',
    theNumberOfGeneralprecisionTests: '普/精检实检数',
    generalqualityInspectionQuantityIsPoor: '普/精检数量差',
    theNumberOfBadSpermatologicalTests: '普/精检不良数',
    clothLabelFeedbackIsPoor: '布标反馈不良',
    orderData: '下单数据',
    goodsToBeInspected: '应检品',
    temporarilyPutForwardDefectiveGoods: '临时提出检品不良',
    submitTheClothLabelForProcessing: '提交布标处理',
    theClothLabelIsFinished: '布标处理完了',
    numberOfLabelsToBeLaid: '待布标处理数',
    quantityOfClothLabelProcessing: '布标处理数量',
    theQuantityOfClothProcessingIsPoor: '布标处理数量差',
    numberOfDefectiveClothLabels: '布标不良数',
    numberOfGeneralprecisionTestProblems: '普/精检问题数',
    quantityPriceFreightModification: '数量价格运费修改',
    calculateTheDataAfterModification: '修改后数据计算',
    productReturnAndExchange: '产品退换货',
    quantityPriceFreightModification: '数量价格运费修改',
    rehashTheProblemProduct: '重提问题产品',
    problemProductCancellation: '问题产品取消',
    isProblemProductCancellation: '确认问题产品取消？',
    returnToPendingBusinessDecision: '退回待业务决策',
    isReturnToPendingBusinessDecision: '确认退回待业务决策？',
    priceAfterEntryIntoGold: '入金后价格',
    modifiedData: '修改后数据',
    temporaryRemarks: '临时备注',
    porderType: '配送单类别',
    deliveryOrderSubmissionTime: '配送单提交时间',
    formOfShipment: '出货形式',
    numberOfWords: '番数',
    associateASuborderNumber: '关联子单号',
    modifyTheStatus: '修改状态',
    consolidationOfDistributionOrder: '配送单合并',
    porderLengthPrompt: '选择的配送单需要大于等于2个',
    consolidationOfDistributionOrderPrompt: '配送单合并完成之后，将删除合并的配送单，生成新的配送单。',
    clearFBAData: '清空FBA数据',
    identificationFBA: '标识贴标',
    cancelTheFBAIdentifier: '取消贴标标识',
    isCancelTheFBAIdentifier: '确定取消FBA标识？',
    generalDistributionList: '普通配送单',
    fBADeliveryOrder: 'FBA配送单',
    shippingOrdersAndShippingOrders: '配送单并单出货',
    fBAOperation: 'FBA操作',
    numberOfTagMatches: '标签匹配数量',
    labelNo: '标签号',
    commodityCode: '商品码',
    numberOfLabels: '标签数量',
    editAndModify: '编辑修改',
    complete: '完成',
    confirmProcessingIsComplete: '确认处理完成',
    commitChanges: '提交修改',
    intoGeneralStorage: '入普通仓库',
    intoChargeWarehouse: '入收费仓库',
    returnToContainer: '退回装箱中',
    generateDeliveryOrder: '生成配送单',
    isGenerateDeliveryOrder: '确认生成配送单？',
    boxNo: '箱子编号',
    packingTime: '装箱时间',
    stateOfTheBox: '箱子状态',
    currentOrderStatus: '当前订单状态',
    orderNotShipped: '未出货订单',
    updateTime: '更新时间',
    notesOnPackingOfGoods: '配货装箱备注',
    salesmanPackingNotes: '业务员装箱备注',
    markingAndLabeling: '标识贴标',
    isMarkingAndLabeling: '确认标识贴标？',
    orderToBePacked: '配货单待装箱',
    deliveryOrderToBeQuoted: '配送单待报价',
    deliveryOrderToBePaid: '配送单待支付',
    deliveryOrderToBeShipped: '配送单待出货',
    invoiceItemNameEditing: '发票品名编辑',
    associateTheSubDeliverySingleNumber: '关联子配送单单号',
    distributionOrderSplitting: '配送单拆分',
    labelNumberAdd: '新建标签',
    tagMatching: '标签匹配',
    submitToDistribution: '提交给配货',
    attachment: '附件',
    rate: '汇率',
    detailsOfOtherExpenses: '其他费用明细',
    internationalFreight: '国际运费',
    theCustomerSpecifiesTheSendingMode: '客户指定发送方式',
    serviceSelectTheSendingMode: '业务选择发送方式',
    numberOfLabels: '标签数量',
    numberOfTags: '标签数',
    tagMatchingNumber: '标签匹配数',
    titleEditor: '品名编辑',
    shippingListPackingDetailsDownload: '配送单装箱明细下载',
    shippingListPackingDetailsLook: '配送单装箱明细查看',
    detail: '详细',
    libraryLocationInformation: '库位信息',
    splitToNewDeliverySingular: '拆分到新配送单数',
    surplusQuantity: '剩余数量',
    returnToTranslation: '退回待翻译',
    unpack: '取消装箱',
    actualWeightS: '实重',
    packingNumber: '装箱数',
    takeItOutToASpecificTransactionNumber: '取出到具体交易号数量',
    internationalFreightCalculation: '计算国际运费',
    sendingModeSelection: '发送方式选择',
    theBoxesAreSplitIntoTheNewDeliveryOrder: '箱子拆分到新配送单',
    uploadActualDeliveryNumber: '上传实际纳品数',
    selectEachBoxForInternationalFreightReference: '选中各箱国际运费参考',
    totalNumberOfBoxesDelivered: '配送单总箱数',
    numberOfBoxesCurrentlySelected: '当前选中箱数',
    billingData: '计费数据',
    totalRealWeight: '合计实重',
    totalWeightPao: '合计抛重',
    specificSendingMode: '具体发送方式',
    chargeType: '收费类别',
    nominalCharge: '收费名义',
    theAmountChargedYuan: '收费金额.元',
    theAmountChargedRi: '收费金额.円',
    otherChargesForTheSpecificDeliveryMethodOfTheDeliveryOrder: '配送单具体发送方式其他费用',
    selectTheItemWithTheSameID: '选中同ID商品',
    productDescriptionInChinese: '商品中文描述',
    labelNumberEditing: '标签编号编辑',
    codingRule: '编码规则',
    labelCommodityManagementCode: '标签商品管理编码',
    labelDisplayContent: '标签显示内容',
    displaySequence: '显示顺序',
    contentCategory: '内容类别',
    specificContent: '具体内容',
    tagType: '标签类别',
    requotationOfDeliveryOrder: '配送单重新报价',
    internationalLogisticsDistributionIsProposed: '国际物流配送提出',
    isInternationalLogisticsDistributionIsProposed: '确定国际物流配送提出？',
    fillInTheLogisticsNumberInBatches: '批量填写物流单号',
    obtainTheLogisticsTrackingNumber: '获取物流单号',
    serviceShippingMarkPrint: '业务唛头打印',
    printedSheet: '面单打印',
    fillInTheLogisticsOrderNumberInBatch: '批量填写物流单号',
    numberOfBoxesSelected: '选中箱数',
    afterSale: '售后',
    statusOfLogisticsOrderNumber: '物流单号状态',
    invoiceStatus: '发票状态',
    shippingMarkStatus: '唛头状态',
    invoiceEditingInterface: '发票编辑界面',
    packingDetails: '装箱数据明细',
    summaryOfCurrentInvoiceInformation: '当前发票信息概况',
    currentDate: '当前日期',
    meterThrowRatio: '计抛比例',
    deliveryListNumber: '配送单箱号',
    throwWeight: '抛重',
    senderInformation: '发件人信息',
    companyName: '公司名称',
    originatingAddress: '发件地址',
    contactNumber: '联系电话',
    commodityInformation: '商品信息',
    JapaneseName: '日语品名',
    SubtotalYen: '小计(日元)',
    Subtotal$: '小计(美元)',
    SubtotalRMB: '小计(RMB)',
    SubtotalYuan: '小计(元))',
    productNameEditor: '商品品名编辑',
    finishedSaving: '保存完了',
    invoiceFormDownload: '发票表格下载',
    invoiceInitialization: '发票初始化',
    isInvoiceInitialization: '是否确定发票初始化？',
    japaneseMaterial: '日语材质',
    chineseName: '中文品名',
    chineseProductDescription: '中文商品描述',
    commodityCode: '商品编码',
    customerSellingStoreInformation: '客户售卖店铺信息',
    automaticallyGenerateTraffickedLinks: '自动生成贩卖链接',
    userCode: '客户邮编',
    use: '用途',
    commodityLabelNumber: '商品标签编号',
    salesScreenshot: '售卖截图',
    exportPackingDetails: '导出装箱明细',
    actualWeight: '实际重量(kg)',
    remarksSingleRemarks: '备注单番备注',
    labelManagement: '标签管理',
    label: '标签',
    distributionService: '分配业务',
    allocationPurchase: '分配采购',
    distributionOfGoods: '分配配货',
    customerLoginName: '客户登录名',
    expirationTimeOfMembership: '会员到期时间',
    putAway: '收起',
    orderList: '订单列表',
    helpCustomersPickUpOrders: '帮客户提订单',
    basicInformation: '基础信息',
    customerAccountInformation: '客户账号信息',
    passwordReset: '密码重置',
    SystemID: '系统ID',
    lastAccessTime: '上次访问时间',
    systemLoginName: '系统登录名',
    fullName: '全名(真名)',
    accountStatus: '账户状态',
    membershipLevel: '会员等级',
    commissionRate: '手续费比例',
    introductionLecturer: '介绍讲师',

    quotaMember: '定额会员',
    expirationDateOfMembership: '会员到期日期',
    currentAccountBalance_yen: '当前账户余额(円)',
    accumulatedValueOfTheProduct_yen: '累计商品金额(円)',
    authorizeArrears_yen: '授权欠费额度(円)',
    authorizeOverdueTime: '授权欠费时间',
    authorizedArrearsDocument: '授权欠费文件',
    newCustomerOfferExpires: '人工设置优惠到期',
    authorizationStatus: '授权状态',
    packingAuthorization: '装箱授权',
    latestOrderTime: '最新下单时间',
    latestDaigouOrderTime: '代购最新加单时间',
    latestOemOrderTime: 'OEM最新加单时间',
    latestSmallOrderTime: '小件最新加单时间',
    customerLabel: '客户标签',
    invoiceRelatedInformation: '发票相关信息',
    invoiceRatio: '发票比例',
    customerSalesPlatform: '客户售卖平台',
    amazonStoreInformation: '亚马逊店铺信息',
    yahooStoreInformation: '雅虎店铺信息',
    lotteStoreInformation: '乐天店铺信息',
    other: '其他',
    openMembership: '开通会员',
    invoiceScaleSetting: '发票比例设置',
    quotaMembershipOpening: '定额会员开通',
    chatToolSettings: '聊天工具设置',
    setTheAmountOfAuthorizedArrears: '授权欠费额度设置',
    authorizedLimit: '授权额度',
    userStatus: '客户状态',
    customerSalesPlatformSetting: '客户售卖平台设置',
    screenshotOfSellingStoreInformation: '售卖店铺信息截图',
    detailed: '詳細',//詳細
    directAdditionalGoods: '直接追加商品',//直接追加商品
    shoppingCartAdd: '购物车追加',//购物车追加
    inventoryAddition: '商品库追加',//商品库追加
    amountOfGoods: '商品金額',//商品金額
    submitOrder: '提出订单',//提出订单
    orderGoodsDirectlyAdded: '订单商品直接添加',//订单商品直接添加
    submit: '提交',//提交
    increaseOrDecrease: '增减',//增减
    pleaseEnterTheMerchandiseLinkForRakumratPlatform: '请输入rakumrat平台的商品链接',//请输入rakumrat平台的商品链接
    pleaseAddAtLeastOneItem: '请至少添加一个商品',//请至少添加一个商品
    newTotal: '合計',//合計
    amountTotal: '合计金额',//合计金额
    internationalShippingSentakuSociety: '国際運送会社選択',//国際運送会社選択
    attachmentUploading: '附件上传',//附件上传
    clickUpload: '点击上传',//点击上传
    userSubmitOrderRemark: '注文書備考欄',//注文書備考欄
    userSubmitOrderRemarkTips: '* 对该订单有特殊要求的，可以在这边备注\n' +
      '* 备注后会同步显示给业务员',//* 对该订单有特殊要求的，可以在这边备注* 备注后会同步显示给业务员
    sentaku: "選択",//選択
    photo: "写真",//写真
    lowerSingular: "下单数",//下单数
    unitPriceYuan: '单价.元',//单价.元
    subtotalYuan: '小计(元)',//小计(元)
    labelSetting: '标签设置',//标签设置
    remarksField: '备注栏',//备注栏
    optionDetails: 'オプション詳細',//オプション詳細
    commodityWarehouse: '商品库',
    favorites: '收藏夹',
    failure: '失效',
    managementDesignation: '管理番号',
    commodityTitle: '商品标题',
    addToOrder: '追加到订单',
    selected: '已选',
    shoppingCart: '购物车',
    change: '更改',
    operationAndMaintenance: '运维',
    makeAPublicAnnouncement: '发布公告',
    accountOfBackgroundAdministrator: '后台管理人员账号',
    noticeAnnouncementPreview: '通知公告预览',
    theProportionAllocatedToItselfWhenThereAreLowerLevels: '有下层级时 分配到自身的比例',
    afterSaleOfSpecificGoods: '具体商品售后',
    afterTheWholeOrder: '整个单子售后',
    deliveryRate: '配送单汇率',
    problemLogisticsNumber: '问题物流号',
    afterSaleReasonSelection: '售后原因选择',
    customerFeedbackProblem: '客户反馈问题',
    whetherTheCustomerInterfaceDisplays: '客户界面是否显示',
    problemScreenshotAdd: '问题截图添加',
    adviceOnAfterSaleHandlingOfBusiness: '业务售后处理意见',
    afterSaleExpenseAdjustmentDetails: '售后费用调整明细',
    nominalCostAdjustment: '费用调整名义',
    remarks: '备注说明',
    amountOfIndemnityYen: '赔款金额（円）',
    amountCharged: '收费金额（円）',
    aggregateAdjustment: '合计调整',
    screenshotOfAfterSalesProcessConfirmatio: '售后处理确认过程截图',
    putForwardInBulk: '批量提出',
    contactCustomer: '联系客户',
    customerFeedbackProblemRequestJP: '客户反馈问题诉求（日语）',
    adviceOnAfterSaleHandlingOfBusinessJP: '业务售后处理意见（日语）',
    amountOfIndemnity: '赔款数量',
    indemnitiesForGoods: '商品代赔款',
    returnOfDomesticFreight: '国内运费返还',
    commissionIndemnity: '手续费赔款',
    optionForCompensation: 'option赔款',
    orderRate: '订单汇率',
    purchaseNumber: '购买数',
    numberOfTransmissions: '发送数',
    refundModeEditing: '退款模式编辑',
    compensationForAdditionalServices: '附加服务赔款',
    paidFor: '已收费用',
    theEstimatedAmountOfCompensation: '预计赔款金额',
    goodsAfterSale: '商品售后提出',
    toBeProcessed: '待处理',
    customerToBeRepliedTo: '待回复客户',
    claimNumber: '赔款单号',
    afterSalesOrderNumber: '售后单号',
    indemnityStatus: '赔款状态',
    afterSaleCategory: '售后类别',
    chargeAdjustmentNominalSettingsThroughoutTheList: '整个单子费用调整名义设置',
    wholeListOfAftermarketReasonsSet: '整个单子售后原因设置',
    wafterSalesTime: '售后时间',
    totalIndemnity: '合计赔款.円',
    associatedReparations: '关联赔款',
    nominalSetting: '名义设置',
    causeSetting: '售后原因设置',
    afterSaleStatus: '售后状态',
    indemnityBearingRatio: '赔款承担比例',
    estimatedLiability: '预计承担金额',
    detailsOfAfterSalesOrder: '售后单详情',
    causeOfTheProblem: '产生问题原因（内部）',
    addAnInternalClaimSlip: '添加内部赔款单',
    liabilityForLoss: '赔款承担',
    claimIndemnity: '提出赔款',
    billOfIndemnity: '赔款单',
    categoryOfResponsiblePerson: '责任人类别',
    theOrganizationOfThePersonResponsible: '责任人所在组织',
    companyEmployee: '公司员工',
    externalLogisticsCompany: '外部物流公司',
    thirdPartySeller: '第三方卖家',
    detailsOfExpensesBorne: '承担费用明细',
    responsiblePersonSelection: '责任人选择',
    responsiblePersonRole: '责任人角色',
    bearingRatio: '实际赔款',
    liablePerson: '责任承担人',
    myself: '本人',
    companyResponsibility: '公司承担',
    corporation: '公司',
    associatedResponsiblePerson: '关联责任人',
    billOfIndemnityAdded: '添加赔款单',
    confirmationOfClaims: '赔款确认',
    maximumIndemnity: '赔款上限',
    contrabandSurveillance: '违禁品监控',
    toBeConfirmedByYiwu: '待义乌确认',
    subjectToConfirmation: '待营运确认',
    subjectToJapanConfirmation: '待日本确认',
    processingClass: '处理类别',
    monitoringReason: '监控原因',
    addMonitoredGoods: '添加监控商品',
    commodityMasterChart: '商品主图',
    manuallyAddPictures: '人工添加图片',
    operatingTime: '操作时间',
    monitorProductSettings: '监控商品设置',
    isCustomsIntercepted: '是否被海关拦截过',
    enableAutomaticAcquisition: '开启自动获取',
    commoditySource: '商品来源',
    imageAddition: '图片添加',
    customerSearchKeywordMaintenance: '客户搜索关键词维护',
    fillKeywordValue: '填充关键词值',
    artificialCorrectionOfKeywords: '人工修正的关键词',
    googleAutomaticallyTranslatesValues: '谷歌自动翻译值',
    commoditySpecificationMaintenance: '商品规格维护',
    systemEntryTim: '系统录入时间',
    chineseAttribute: '中文属性',
    manualCorrectionTranslation: '人工修正翻译',
    whetherTheServiceProcessIsSatisfactory: '服务流程是否满意',
    whetherToConfirmTheCurrentRating: '是否确认当前评价',
    homogeneousGrouping: '同分类分组',
    logisticsNumberSelection: '物流号选择',
    printed: '已打印',
    notPrinted: '未打印',
    statusOfAllInspectedProducts: '全部检品状态',
    batchAddRemarks: '批量添加备注',
    lecturerSWithdrawal: '讲师提现',
    lecturerName: '讲师名字',
    LecturerID: '讲师ID',
    subordinateDepartment: '所属部门',
    shelfSetting: '货架设置',
    orderbianhao: '订单编号',
    select: '选中',
    fullNamePM: '全部品名',
    nonStandardName: '非标准品名',
    allCustomers: '全部客户',
    numberOfProblems: '问题数',
    pleaseEnterTheShippingNumber: '请输入配送单号',
    pleaseEnterID: '请输入ID',
    pleaseEnterTheOrderNumber: '请输入订单号',
    labelImportQuantity: '标签导入数量',
    deliveryTimeOfPresentation: '配送提出时间',
    customerDeliveryNote: '客户配送单商品备注',
    transactionLogisticsNumber: '交易/物流号',
    numOfLabels: '贴标标签数',
    shippingTime: '出货时间',
    confirmAndPropose: '确认提出',
    picture: '图片',
    remitter: '汇款人',
    remittanceAmoun: '汇款金额(円)',
    remittanceCustomer: '汇款客户',
    numberOfRemovableLibraries: '可移库数',
    startCharging: '开始计费',
    daysBilled: '已计费天数',
    CStime: '初始时间',
    specification: '规格',
    rotograph: '轮播图',
    defaultRecommendation: '默认推荐',
    dateOfRevision: '修改日期',
    searchResult: '搜索结果',
    timeOfClaim: '认领时间',
    pleaseEnterTheTrackingNumber: '请输入快递单号',
    signerSelection: '签收员选择',
    overallEvaluationOfDeliveryOrder: '配送单整体评价',
    viewDetails: '查看明细',
    customerEvaluation: '客户评价',
    problemDescriptionMS: '问题描述',
    deleteChangeMode: '删除改方式',
    nameOfLogisticsMode: '物流方式名称',
    modifiedSortNumber: '修改后排序编号',
    customerSingleFlipRemarks: '客户单翻备注',
    theCustomerSelectsThePropertyOfTheItem: '客户选择商品属性',
    sortNumbering: '排序编号',
    commodityMonitoring: '商品监控',
    fillInTheGoogleKeywordValue: '填充谷歌关键词值',
    fillInTheCustomerInputKeywordValues: '填充客户输入关键词值',
    maintenanceTime: '维护时间',
    maintenanceName: '维护人',
    searchDate: '搜索日期',
    formOrder: '下单模板',
    placeANewOrder: '提出新订单',
    packingQuantit: '装箱数量',
    addSalesScreenshots: '售卖截图添加',
    confirmUpload: '确认上传',
    comprehensiveLabel: '综合标签',
    ruleTag: '规则标签',
    serviceLabel: '业务标签',
    labelStatus: '标签状态',
    retrievalTimes: '检索次数',
    numberOfCustomers: '客户数',
    createACommunity: '创建群体',
    tagName: '标签名',
    commodityCommissionRatioConfiguration: '商品手续费比例配置',
    effectiveRule: '生效规则',
    currentActiveCommissionRate: '当前生效手续费比例',
    commissionRateAdjustment: '手续费比例调整',
    effectiveCommissionRate: '生效手续费比例',
    labelDistributionSingleListInterface: '贴标配送单列表界面',
    fBAOperationStatus: 'FBA操作状况',
    assignFBAOperations: '分配FBA操作',
    toBeAllocated: '待分配',
    toBeLabeled: '待贴标',
    labelin: '贴标中',
    pendingDeposit: '待入金',
    deliveryReceiptAfterReceiptOfCash: '入金后配送单',
    serialNumber: '序号',
    timeFKPayment: '付款时间',
    fullPurchase: '全部采购',
    linkedList: '链接列表',
    startTime: '开始时间',
    endTime: '结束时间',
    orderPersonnelAdjustment: '订单人员调整',
    roundDisplay: '整番显示',
    roundHide: '整番隐藏',
    expandTheDisplay: '各番展开显示',
    commodityNoteEditing: '商品备注编辑',
    BearCommodityNoteEditing: '担当、商品备注',
    purchaseCommodityNoteEditing: '采购、商品备注',
    DistributionBearCommodityNoteEditing: '配货、商品备注',
    containerTransferQuantity: '移箱数量',
    fBATranslationTime: 'FBA翻译时间',
    labelingTime: '贴标时长（h）',
    numberOfCopiesPrinted: '已打印数',
    numberOfServiceLabelsModifiedRemarks: '业务贴标数修改备注',
    specificTimePoint: '具体时间点',
    markingTime: '给标时间',
    timeToStartLabeling: '开始贴标时间',
    finishLabelingTime: '完成贴标时间',
    viewRemarks: '查看备注',
    fBAOperationRemarks: 'FBA操作备注',
    confirmToFillInTheOrderNumber: '确认填写单号',
    fBAOperationSelect: 'FBA操作选择',
    fBAOperationWorkloadStatus: 'FBA操作工作量状况',
    unpastedDeliverySingular: '未贴完配送单数',
    numberOfUnpastedLabels: '未贴完标数',
    attributesOfGoodsPlacedByCustomers: '客户下单商品属性',
    isBackToWaitTranslate: '是否回退到待翻译？',
    returnService: '退给业务',
    requotationRecordOfDeliveryOrder: '配送单重新报价记录',
    backoffReasonSetting: '回退原因设置',
    backoffChargeNominalSetting: '回退收费名义设置',
    backOffTheTimeOfReOffer: '回退重新报价时间',
    deliveryOrderNumber: '配送单单号',
    personOfReturn: '回退人',
    organizationOfAffiliation: '所在组织',
    deliveryOrderOperator: '配送单操作员',
    reasonForBackOff: '回退原因',
    whetherTheInternationalFreightIsRefunded: '国际运费是否回退',
    photoNotes: '图片备注',
    theReasonForTheBackoffIsExplained: '回退原因说明',
    detailsOfChangesInExpenses: '费用变动明细',
    newCategoriesAdded: '新增类别',
    returnTheAdditionalCharge: '回退追加收费名义',
    deliveryOrderRollbackRequotationRecord: '配送单回退重新报价记录',
    detailsAboutTheRollback: '具体回退说明',
    screenshotAddition: '截图添加',
    returnToCustomer: '退给客户',
    noReturnToCustomer: '不退给客户',
    whetherToReturnToTheCustomer: '是否退给客户',
    additionalCharge: '追加收费',
    returnToRegularWarehouse: '退回常规仓库',
    warehouseAddressMaintenance: '仓库地址维护',
    warehouseCode: '仓库编码',
    statusOfEnable: '启用状态',
    warehouseAddress_English: '仓库地址（英文）',
    warehouseAddress_Japanese: '仓库地址（日文）',
    nameOfWarehouse: '仓库名',
    newBuild: '新建',
    add_Warehouse: '添加-仓库',
    edit_Warehouse: '编辑-仓库',
    typeOfWarehouse: '仓库类别',
    whetherEnabled: '是否启用',
    APPVersionControl: 'APP版本控制',
    Android: '安卓',
    IOS: '苹果',
    officialPackageName: '正式包名',
    timeOfRelease: '发布时间',
    popUpCopy_Japanese: '弹窗文案（日文）',
    popUpCopy_Chinese: '弹窗文案（中文）',
    whetherItIsStronger: '是否强更',
    versionNumber: '版本号',
    checkEmail: '邮件查看',
    additionalServicesJapanese: '附加服务日文',
    combinationOfOrders: '订单合单',
    orderUnpacking: '订单拆单',
    orderPrefixSetting: '下单前缀设置',
    orderPhoneSettings: '下单手机设置',
    recipientSMobileNumber: '收件人手机号',
    firmOffer: '确认谈价',
    confirmFreight: '确认运费',
    excelOrder: 'Excel下单',
    deliveryOrderDeletion: '配送单删除',
    remittanceAmount_yen: ' 汇款金额(円)',
    printList: ' 打印清单',
    qrCodeUpload: '二维码上传',
    sameTransactionNumbe: '同交易号',
    duplicateLogisticsNumbe: '复制物流号',
    arrivalTime: '到货时间',
    names: '名称',
    // 新建
    porderList: '配送单列表',
    plainTextLabel: '纯文字标',
    textLabel: '文本标',
    rateAtTimeOfPayment: '付款时汇率',
    batchRollback: '批量回退',
    fullRemittance: '全部汇款',
    toBeRemitted: '待汇款',
    remittanceHasBeenMade: '已汇款',
    bulkFilling: '批量填充',
    adjustTheSpreader: '调整布标员',
    // 11111
    numberOfBidDemolitions: '实缝标数',
    numberOfActualSplitBids: '实拆标数',
    liberalSVIP: '开通SVIP',
    OfflSVIP: '关闭SVIP',
    orderDownload: '订单下载',
    purchaseBargaining: '采购谈价',
    negotiatedUnitPrice: '谈价单价',
    negotiatedFreight: '谈价运费',
    actualNumberOfTags: '实际标签数',
    expectedNumberOfTags: '预计标签数',
    editPic: '修改头像',
    editPassword: '修改密码',
    dueIndemnity: '理应赔款',
    shippingMarkForDistribution: '配货打印唛头',
    jianpinCenter: '检品中',
    manualOrderingOnTaobao: '淘宝人工下单',
    userRamrk: '运营备注',
    userBeikao: '客户备注',
    numberOfArrivals: '到货番数',
    subaccountID: '子账号ID',
    ChuliTime: '处理时间',
    reasonForCompensation: '赔款原因',
    totalIndemnityYuan: '合计赔款.元',
    newOrderCompensation: '新建订单赔款',
    actualCompensation: '实际赔款',
    actualCommitmentAmount: '实际承担金额',
    boundInstructor: '绑定讲师',
    batchDeleteLabels: '批量删除标签',
    actualPayment: '实际需支付',
    read: '已读',
    unread: '未读',
    printPackingListNoPrice: '打印装箱单',
    businessProcessing: '业务处理',
    jurisdiction: '权限',
    japaneseOffice: '日本事务所',
    customerBaseInformation: '客户基础信息',
    customerProfilePicture: '客户头像',
    chat: '聊天',
    latestChatTime: '最新聊天时间',
    deliveryOrderInProgress: '进行中配送单',
    feedback: '意见反馈',
    fillInReason: '填写原因',
    newEmergency: '新增紧急件',
    inspectionDetail: '检品详细',
    financialAuditRemarks: '财务审核备注',
    updatePurchaseRemark: '修改购买备注',
    mailSending: '邮件发送',
    mailTitle: '邮件标题',
    mailContent: '邮件内容',
    theEmailSubjectCannotBeBlank: '邮件标题不能为空',
    theEmailContentCannotBeEmpty: '邮件内容不能为空',
    mailList: '邮件列表',
    topicKeyword: '主题关键词',
    notViewed: '未查看',
    viewed: '已查看',
    sender: '发送人',
    sendingTime: '发送时间',
    mailDetails: '邮件详情',
    // 未翻译
    mingYi: '名义',
    transferNoteNei: '转账备注(内部)',
    // 9.25新增
    bankName: '银行名',
    scanningTime: '扫描时间',
    scanBarCode: '扫描条码',
    labelComparison: '标签比对',
    tagCoding: '标签编码',
    labelCheck: '核对',
    chineseDomesticLogistics: '中国国内物流',
    noLogisticsInformation: '暂无物流信息',
    salesmanIndex: '业务员首页',
    purchaseIndex: '采购员首页',
    distributionIndex: '配货员首页',
    testArticleIndex: '检品员首页',
    deliverableOrder: '可发货订单',
    manualSetupFreeOfCharge: '人工设置免手续费',
    liberal: '开通',
    startingFeeFreeDate: '人工设置开始日期',
    endOfFeeFreeDate: '人工设置结束日期',
    overdue: '紧急',
    isOverdue: '是否紧急',
    numberOfLabelEntries: '贴标填写数',
    causeOfInconsistency: '不一致的原因',
    businessCommodityNotes: '业务的商品备注',
    depositInformation: '入金信息汇总',
    flowDetailFuzzyMatching: '流水明细模糊匹配',
    exactMatchingOfAmounts: '金额精确匹配',
    matchingState: '匹配状态',
    paymentDetailsContents: '出入金明细（内容）',
    systemSerialNumber: '系统流水号',
    otherRemarks: '其他备注',
    currentBalance: '当时余额',
    depositAmount: '入金金额(円)',
    withdrawalAmount: '出金金额(円)',
    journalDetail: '流水明细',
    flowNumber: '流水编号',
    bankStatementDate: '银行流水日期',
    importDate: '导入日期',
    automaticFinancialRecognition: '自动财务确认',
    uploadStream: '上传流水',
    selectFile: '选择文件',
    depositName: '入金名义（给客户的)',
    purchaseAllocation: '采购分配',
    distributionAllocation: '配货分配',
    generateLink: '生成链接',
    kunbaozhong: '梱包中',
    depositNominalMaintenance: '入金名义维护',
    bank: '银行',
    currentDefaultName: '当前默认名义',
    setAsDefault: '设为默认',
    currentDefault: '当前默认',
    itWentOnTheShelves90DaysAgo: '90天前上架完',
    purchaseDocumentaryRemarks: '采购跟单备注',
    orderPendingDeposit: '订单待入金',
    orderDepositToBeConfirmed: '订单入金待确认',
    porderWaitPaySubmit: '配送单待入金',
    porderPayWaitConfirm: '配送单入金待确认',
    blockMail: '屏蔽邮件',
    pendingBusinessConfirmation: '待业务确认',
    toBeReviewed: '待审核',
    waitingForPayment: '等待打款',
    customerConfirmation: '客户确认',
    serviceConfirmation: '业务确认',
    examine: '审核',
    finalPurchaseCost: '最终采购成本',
    communicationScreensho: '沟通截图',
    auditRemarks: '审核备注',
    copyTheWithdrawalLink: '复制提现链接',
    estimatedTimeOfArrival: '预计到账时间',
    abandon: '废弃',
    abandonmentApplication: '废弃申请',
    reasonForAbandonment: '废弃原因',
    requestForCancellationOfDeliveryOrder: '配送单废弃申请',
    confirmationPersonnelRemark: '确认人员备注',
    proposedObsolescenceTime: '提出废弃时间',
    topUp: '充值',
    paymentInformation: '打款信息',
    paymentVoucher: '打款凭证',
    flowMatching: '流水匹配',
    userEmail: '客户邮件',
    emailSubject: '邮件主题',
    Nodata: '暂无数据',
    userChat: '客户聊天',
    ordinaryCustomer: '普通客户',
    potentialCustomer: '潜力客户',
    whetherToRenewQuotaMembership: '是否续费定额会员',
    Settings: '设置',
    renewalQuotaMember: '续费定额会员',
    lastUpdateTime: '最新更新时间',
    inspectionTransactionSearch: '交易号（检品操作）',
    inspectionLogisticsSearch: '物流号（检品操作）',
    commissionCommitment: '手续费承担',
    rakuUndertake: 'rakumart承担',
    userUndertake: '客户自行承担',
    financialOperationTim: '财务操作时间',
    depositName: '入金名义',
    alreadyMatched: '已匹配',
    unmatch: '未匹配',
    sameOrderSearch: '同订单搜索',
    switchView: '切换视图',
    submissionTime90Days: '提出时间90天',
    depositNominalFuzzySearch: '入金名义模糊搜索',
    generateNetEaseOrders: '生成网易订单',
    discardType: '废弃类型',
    customerRequestAbandonment: '客户要求废弃',
    unableToContactTimeoutDiscard: '联系不上超时废弃',
    pipelining: '流水绑定',
    confirmThatYouWantToStreamBind: '确认要流水绑定？',
    reminderTimes: '提现次数',
    theNumberOfAdditionalServicesIsAbnormal: '附加服务数量异常',
    numberOfCloth: '布标数',
    historyTag: '历史标签',
    commodityManagementCode: '商品管理编码',
    Kintype: '类别',
    returnToTemporaryStorage: '退回临时保存',
    isReturnToTemporaryStorag: '是否退回临时保存？',
    expectedNumberOfLabels: '预计贴标数',
    clientBillList: '客户账单',
    dataSourceName: '数据源名称',
    timeSelection: '时间选择',
    lastAppointment: '上一次预约',
    dataSource: '数据源',
    downloadByAppointment: '预约下载',
    subscriptionCompletionTime: '订阅完成时间',
    timeToSubmitDeposit: '提交入金时间',
    confirmDepositTime: '确认入金时间 ',
    thereIsNoFlowMatchin: '暂无流水匹配 ',
    purchaseProposalTime: '采购提出时间 ',
    inAbout5Days: '近5天上架完',
    partialRemittance: '分批汇款',
    paymentAmountSetting: '支付金额设定',
    payOnFirstPayment: '付首款时付',
    payWithTheBalance: '与尾款一起支付',
    finalPaymentNode: '尾款支付节点',
    preWarehouse: '上架仓库前',
    beforeDeliveryOrder: '提配送单前',
    theFirst: '首款',
    balancePayment: '尾款',
    orderPaymentMethod: '订单支付方式',
    HScode: 'HS编码',
    markedWoodenCase: '标记木箱',
    unmarkedCase: '取消标记木箱',
    bindingPurchase: '绑定采购',
    bindingAllocation: '绑定配货',
    markManuallyReviewed: '标记已人工审核',
    estimatedMonthlyOrderAmount: '月预估下单额',
    batchConfirmationInJapan: '运营批量确认',
    qaManage: '前台QA配置',
    addACategory: '添加一类类目',
    addQuestion: '添加题目',
    categoryName: '类目名',
    subject: '题目',
    answer: '答案',
    addCategory: '添加类目',
    editCategory: '编辑类目',
    editQuestion: '修改题目',
    batchAllocationOfInspectionProportion: '检品比例批量分配',
    websiteConsultation: '网站咨询',
    numberOfDeliveryOrdersProposed: '已提出配送单数',
    refundAmountVoucher: '退款金额凭证',
    uploadSpecialCustomerTags: '特殊客户标签上传',
    pendingProcurementReview: '待采购审核',
    reviewed: '已审核',
    pleaseSelectTheType: '请选择类型',
    defaultImporter: '默认进口商',
    defaultShippingAddress: '默认收货地址',
    blacklistedStoreOrderNumber: '黑名单店铺订单号',
    setRemarks: '设置备注',
    documentaryRemarks: '跟单备注',
    history: '历史',
    documentaryRemarksSettings: '跟单备注设置',
    promptPersonnel: '提示人员',
    historyRemark: '历史记录',
    viewSituation: '查看情况',
    reminderForTrackingNotes: '跟单备注提示',
    timedMembershipActivation: '定时开通会员',
    customerMarking: '客户标记',
    modifyName: '修改名称',
    batchDeletion: '批量删除',
    batchAdjustmentOfOrders: '订单批量调整',
    batchAdjustmentOfDeliveryOrders: '配送单批量调整',
    confirmScreenshot: '确认截图',
    documentaryRecords: '跟单记录',
    addPeople: '添加人',
    remarkTime: '备注时间',
    remarkContent: '备注内容',
    userLink: '客户页面链接',
    websiteUpdateLogs: '网站更新日志',
    updateContent: '更新内容',
    port: '端口',
    releaseDate: '发版日期',
    chatSummary: '聊天信息汇总',
    chatInfo: '聊天信息',
    suspectedComplaint: '疑似投诉',
    confirmComplaint: '确认投诉',
    complaintConfiguration: '投诉配置',
    complaintVocabulary: '投诉词汇',
    recentOrderPlacementTime: '最近下单时间',
    accumulatedShipmentAmount: '累计出货金额',
    sendTo: '发送对象',
    chatContent: '聊天内容',
    confirmStatus: '确认状态',
    suspectedComplaint: '疑似投诉',
    confirmComplaint: '确认投诉',
    nonComplaint: '非投诉',
    whetherToCancelTheComplaint: '是否取消投诉',
    upAndDown: '上下50条',
    photographyServices: '摄影服务',
    photographOrder: '摄影订单',
    correspondingPersonnel: '对应人员',
    createANewTaskOrder: '新建任务单',
    uploadFiles: '上传文件',
    expectedCompletionTime: '预计完成时间',
    numberOfShotsTaken: '拍摄数量',
    taskToBeFilmed: '待拍摄任务',
    actualCompletionTime: '实际完成时间',
    actualNumberOfShotsTaken: '实际拍摄数量',
    photographFile: '摄影文件',
    photographyNotes: '摄影备注',
    toBePhotograph: '待拍摄',
    shootingCompleted: '拍摄完成',
    sendingEmails: '发送邮件',
    classification1688: '1688分类',
    consultationRegistration: '咨询登记',
    qaQuery: 'QA查询',
    qaSummary: 'QA汇总',
    classification: '分类',
    consultationTime: '咨询时间',
    consultationSource: '咨询来源',
    customerConsultationContent: '客户咨询内容',
    replyContent: '回复内容',
    consultationRecords: '咨询记录',
    recordGenerationTime: '记录生成时间',
    lecturerRegistrationExpirationDate: '讲师注册到期时间',
    listMaintenance: '榜单维护',
    listNameChinese: '榜单名称（中文）',
    listNameJapanese: '榜单名称（日文）',
    Pallet1688ID: '1688货盘ID',
    enablingStatus: '启用状态',
    notesFromJapaneseAccountingFirms: '日本事务所备注',
    AIAutomaticAcquisition: 'AI自动获取',
    logisticsName: '物流名称',
    JapaneseRankingExplanation: '日文榜单说明',
    boxKin: '箱子商品总金额',
    getTemporaryPassword: '获取临时密码',
    calculateBusinessPerformance: '算业务绩效',
    calculateDistributionPerformance: '算配货绩效',
    calculateProcurementPerformance: '算采购绩效',
    defaultICON: '默认ICON',
    selectionICON: '选中后ICON',
    optionPic: 'option图片',
    optionVideo: 'option视频',
    reparationType: '赔款类型',
    batchSelectProducts: '批量选中商品',
    joinProductLibrary: '加入商品库',
    joinProductManagement: '加入商品管理',
    joinProductManagementSuccess: '加入商品管理成功',
    joinProductManagementFailed: '加入商品管理失败',
    businessConfirmationTime: '业务确认时间',
    ministerReviewTime: '部长审核时间',
    cancelMembershipActivation: '取消开通会员',
    compensationDetails: '赔款明细',
    responsiblePerson: '责任人',
    actualCompensationAmount: '实际赔款金额',
    correspondingOrganization: '对应组织',
    waitingForProcurement: '等待采购',
    waitingForFinancialPayment: '等待财务付款',
    Unpacking: '拆包',
    inspection: '普检',
    Simplify: '精检',
    SeamMarking: '缝标',
    personnel: '人员',
    abandonedList: '打印废弃单',
    pendingInternalProcessing: '待内部处理',
    ToBeReviewedByTheMinister: '待部长审核',
    Processed: '已处理完成',
    thirdPartyWarehouseAddress: '第三方仓库地址',
    handlingIdeas: '处理思路',
    confirmedComplaint: '确认为投诉',
    CustomerComplainHandling: '客户投诉处理',
    ProcessScreenshots: '处理截图',
    MinistersMessage: '部长留言',
    ImmediateReview: '立即审核',
    mate: '匹配',
    handle: '处理',
    JapaneseMessage: '日本留言',
    SeveritProblem: '问题严重程度',
    ProblemSolvingDuration: '发现问题-解决问题时长',
    CustomeImportance: '客户重要程度',
    BusinessSituation: '业务解决问题的情况',
    score: '评分',
    SeveritProblemText: '严重程度分为1星-5星，星级越高越严重',
    CustomeImportanceText: '重要程度分为1星-5星，星级越高客户越重要',
    BusinessSituationText: '业务解决问题的情况分为1星-5星，星级越高解决得越完美',
    ProblemSolvingDurationText: '时长评分分为1星-5星，星级越高代表时长越短，说明解决得越快',
    strip: '条',
    GoBack: '返回上一页',
    fourSteps: '匹配/处理/审核/确认',
    FuzzySearchHistoricalRecords: '历史记录模糊搜索',
    ministersScreenshot: '部长截图',
    complaintType: '投诉类型',
    raiseAnotherOrder: '再提一单',
    afterSalesReasons: '售后原因',
    isThereACompensationClaim: '是否有赔款单',
    reasonForApplication: '申请原因',
    mergePayments: '合并付款',
    couponSummaryList: '券汇总列表',
    openingTime: '开通时间',
    promotionStartTime: '优惠开始时间',
    endTimeOfDiscount: '优惠结束时间',
    applicationTimeInformation: '申请时间信息',
    couponInformation: '券信息',
    limitnumberOfAvailableTimesdiscountRatio: '额度/可用次数/折扣比例',
    usageInformation: '使用信息',
    canEnterTheSystem: '可进入系统',
    selectRole: '选择角色',
    batchAdjustPermissions: '批量调整权限',
    packagingCompletionTime: '打包完成时间',
    searchTime: '搜索时间',
    partialCustomersSASS: '部分客户-SASS',
    customerDataAnalysis: '客户数据分析',
    overviewInformation: '概况信息',
    afterSalesManagement: '售后管理',
    deliveryNoteInformation: '配送单信息',
    relatedInformation: '相关信息',
    customerDynamics: '客户动态',
    warehouseGoods: '仓库商品',
    domesticDeliveryInProgress: '国内派送中',
    operationLog: '操作日志',
    invoiceRecord: '发票记录',
    depositAndWithdrawalRecords: '出入金记录',
    afterSalesInformation: '售后信息',
    dataDisplayBoard: '数据展板',
    orderStatistics: '订单统计',
    orderQuantity: '订单数量',
    orderAmount: '下单金额',
    saveMoney: '节省金额',
    domesticFreightRatio: '国内运费比例',
    additionalServiceFeeRatio: '附加服务费比例',
    totalKin: '总金额',
    deliveryTime: '纳期',
    shipmentAmount: '出货金额',
    numberOfDeliveryOrders: '配送单数量',
    deliveryOrderStatistics: '配送单统计',
    shipmentAmountY: '出货金额（元）',
    deliveryMethod: '配送方式',
    orderDeliveryTime: '订单纳期',
    numberOfProblematicProductOrders: '问题产品番数',
    customerDepositTime: '客户入金时间',
    expectedShelfLife: '预计上架时间',
    refundAmount: '退款金额',
    wangwang: '旺旺',
    afterSalesQuantity: '售后数量',
    totalAfterSalesAmount: '售后合计金额',
    orderDeliveryNumber: '订单/配送单号',
    completionTime: '完成时间',
    afterSalesAmount: '售后金额',
    correspondingFollowUpPersonnel: '对应跟进人员',
    personnelConfiguration: '人员设置',
    personnelConfigurationSettings: '人员配置设置',
    proportion: '比例',
    followUpPersonnel: '跟进人员',
    actualNumberOfSets: '实际组套数量',
    actualNumberOfCapsules: '实际包膜数量',
    waitingForTheMinisterSReplyToConfirm: '待部长回复确认',
    ministerConfirms: '部长确认',
    japanConfirms: '日本确认',
    ministerialReview: '部长审核',
    ministerConfirmsReply: '部长确认回复',
    beginnerSGuide: '新手指南',
    addDescription: '添加说明',
    groupInformationPull: '群信息拉取',
    massMessaging: '群发信息',
    sendingStatus: '发送状态',
    timedTransmissionTime: '定时发送时间',
    addDate: '添加日期',
    exportSendingDetails: '导出发送详情',
    depositNumber: '入金番号',
    isThereAProblemWithTheProduct: '是否有问题产品',
    specialGroupAddition: '特殊加群',
    createGroup: '创建群组',
    newDeliveryOrderCompensation: '新建配送单赔款',
    compensationAmount: '赔款金额',
    amountOfShippedGoods: '出货商品金额',
    quantityOfShippedGoods: '出货商品数量',
    noProceduresRequiredForDistribution: '免手续发放',
    generateCoupons: '生成券',
    distributeImmediately: '立即发放',
    batchThawing: '批量解冻',
    batchFreeze: '批量冻结',
    willTheSelectedCustomerSAccountBeUnfrozen: '是否将对选中的客户进行账号解冻',
    willTheSelectedCustomerSAccountBeFrozen: '是否将对选中的客户进行账号冻结',
    applyTime: '申请时间',
    addServiceOrder: '新增服务单',
    vacuumCompression: '真空压缩',
    plasticSealing: '塑封',
    bubbleWrapFilm: '包气泡膜',
    supportingFacilities: '配套',
    serviceOrderNumber: '服务单号',
    serviceOperator: '服务操作人',
    serviceOrderAttachment: '服务单附件',
    submitToInspection: '提交给检品',
    operationCompleted: '操作完了',
    serviceProcessing: '服务待处理',
    serviceProgress: '服务处理中',
    serviceCompleted: '服务完成',
    processingQuantity: '处理数量',
    actualProcessing: '实际处理',
    changeRequiredOperationQuantity: '变更需要操作数量',
    enterRequiredOperationQuantity: '请输入需要操作数量',
    changeHandler: '变更处理人',
    batchDispatchInspector: '批量调配检品员',
    selectedInspectionOrderCount: '已选择检品单：{count}',
    inspectionDispatchProgress: '检品单调配进度',
    inspectionDispatchSuccess: '检品单调配完成',
    inspectionDispatchFailed: '检品单调配失败，列表已刷新',
    batchDispatchServiceOperator: '批量调配操作人',
    selectedServiceOrderCount: '已选择服务单：{count}',
    serviceDispatchProgress: '调配进度',
    serviceDispatchSuccess: '服务单调配完成',
    serviceDispatchFailedCount: '{count}个服务单调配失败，列表已刷新',
    startOperation: '开始操作',
    reasonDeletion: '删除原因',
    sassClientList: 'SASS客户列表',
    batchTransfer: '批量转移',
    batchTransferOrderSettings: '批量转移单子设置',
    immediateTransition: '立即转移',
    logisticsInformationInquiry: '物流信息查询',
    logisticsStatus: '物流状态',
    receiversNote: '收件员备注',
    pleaseEnterTheLogisticsTrackingNumber: '请输入物流单号',
    scanned: '已扫描',
    unscan: '待扫描',
    productClassificationFiltering: '商品分类筛选',
    productMarkingSettings: '商品标记设置',
    productMarking: '商品标记',
    tagNameSetting: '标记名称设置',
    businessFollowUpNotes: '业务跟进备注',
    customsClearanceFee: '通关手续费',
    compensationCategory: '赔款类别',
    exportWarehouseData: '仓库数据导出',
    theInvoiceIncludesOtherAmounts: '发票包含其他金额',
    forwardToMembers: '转寄会员',
    forwardingMonthlyFeeDueDate: '转寄月费到期日期',
    addProduct: '追加商品',
    manualOrdering: '人工下单',
    manualOrdering1688: '1688人工下单',
    orderNow: '立即下单',
    confirmOrderPlacement: '确认下单',
    adjustTheOperator: '调整操作员',
    productsInProgress: '进行中的商品',
    historicalProductData: '历史商品数据',
    informationMaintenance: '信息维护',
    toBindManagementNumber: '待绑定管理番号',
    dataMaintenance: '数据维护',
    noNeedToMaintainTheProduct: '无需维护商品',
    productV2NoNeedStatus: '无需维护',
    shopName: '店铺名',
    shopID: '店铺ID',
    factory: '工厂',
    batchRestore: '批量还原',
    selectProductsFromTheSameStore: '选择同店铺商品',
    selectProductsWithTheSameLink: '选择同链接商品',
    reduction: '还原',
    batchBindingOfEXCEL: 'EXCEL批量绑定',
    batchSetManagementNumber: '批量设置管理番号',
    relatedOrders: '关联订单',
    excelOneClickImport: 'EXCEL一键导入',
    import: '导入',
    importOneItemOfProductData: '商品数据一件导入',
    productImportResult: '商品导入结果',
    productImportTotal: '总计',
    productImportUpdated: '成功',
    productImportFailed: '失败',
    productImportSkipped: '跳过',
    productImportAiFixed: 'AI修正',
    productImportDryRun: '本次为预检，未实际写入数据',
    productImportSuccessDetails: '成功明细',
    productImportFailedDetails: '失败明细',
    productImportNoSuccess: '没有成功更新的数据',
    productImportNoFailed: '没有失败数据',
    productImportRow: 'Excel行',
    productImportManagementNo: '管理番号',
    productImportSystemCode: '系统编码',
    productImportColumn: '字段',
    productImportRaw: '原始值',
    productImportReason: '失败原因',
    productImportExpected: '预期',
    productImportExample: '示例',
    productImportSelectFile: '请先选择Excel文件',
    productImportFileType: '只能上传Xls或Xlsx文件',
    productImportUploadFailed: '文件上传失败',
    listExpansion: '列表展开',
    materialExpandAll: '一键展开',
    materialCollapseAll: '一键收起',
    selectProductType: '选择产品类型',
    productManagementRemarks: '商品管理备注',
    customerID_CustomerName: '客户ID/客户名称',
    productLabelMultipleChoice: '商品标签（多选）',
    doYouWantToSetOPTION: '是否设置OPTION',
    isTheLabelBound: '是否绑定标签',
    whetherToBindAuxiliaryMaterials: '是否绑定辅料',
    productName_ProductID_ProductLink: '商品名称/商品ID/商品链接',
    factoryNameFactoryIDFactoryLink: '工厂名称/工厂ID/工厂链接',
    mainImage: '主图',
    bindingAuxiliaryMaterials: '绑定辅料',
    customsClearanceInformation: '通关信息',
    productType: '产品类型',
    tagInformation: '标签信息',
    productNameChinese: '商品名称（中文）',
    productNameJapanese: '商品名称（日文）',
    physicalImage: '实物图',
    packingDiagram: '捆包图',
    productFile: '商品文件',
    productCustomizationFile: "商品定制文件",
    inspectionInstructionBook: '検品指示書',
    photographyGuidebook: '摄影指示书',
    listCollapse: '列表收起',
    productList: '商品列表',
    singleWeightOfProduct: '商品单重',
    automaticallyFollowOrders: '下单自动跟随',
    basicSettings: '基础设置',
    controlOverInvoices: '发票管理',
    productFileManagement: '商品文件管理',
    accessorySettings: '辅料设置',
    optionSettings: 'option设置',
    productLabelManagement: '商品标签管理',
    categoryOfProhibitedItems: '违禁品类别',
    support: '支持',
    noSupport: '不支持',
    uploadPhysicalImage: '实物图上传',
    synchronization: '同步',
    picturePublic: '图片公开',
    warehouseType: '仓库类型',
    usedWhenPlacingAnOrder: '下单时使用',
    fileUpload: '文件上传',
    video: '视频',
    chargingStandards: '收费标准',
    specialRequirements: '特殊要求',
    file: '文件',
    uploadVideo: '上传视频',
    selectSystemOptions: '选择系统option',
    createCustomOptions: '创建自定义option',
    purchaseInformationMaintenance: '购买信息维护',
    purchasingChannels: '购买渠道',
    createFileClassification: '创建文件分类',
    onLine: '线上',
    offline: '线下',
    businessContact: '业务联系人',
    purchasingContactPerson: '采购联系人',
    factoryContact: '工厂联系人',
    pleaseEnterTheNameOfTheContactPerson: '请输入联系人名字',
    contactPhoneNumber: '联系人手机号',
    offlinePaymentMode: '线下付款模式',
    contractDocuments: '合同文件',
    fullPayment: '全款支付',
    partialPayment: '分批付款',
    code: '编码',
    selectEncoding: '选择编码',
    english: '英文',
    hscodeCodeQuery: 'HSCODE编码查询',
    lookup: '查找',
    tariffRate: '关税率',
    sizeWeight: '尺寸/重量',
    latestUpdateTime: '最近更新时间',
    specialProducts: '特殊商品',
    orderRelated: '订单相关',
    orderTime: '下单时间',
    orderQuantity: '下单数量',
    purchaseStage: '购买阶段',
    RAKUMARTWarehouse: 'RAKUMART仓库',
    badData: '不良数据',
    PendingDeliveryToRakumart: '等待送达RAKUMART',
    PendingShipment: '等待发货',
    Purchasing: '购买中',
    DefectResolved: '处理完成',
    DefectPendingDecision: '不良待决策',
    DefectInProgress: '不良处理中',
    ShippableQuantity: '可出货数量',
    InternationalTransport: '国际运送',
    ShipmentOrderPendingConfirmation: '发货单待确认',
    PackingInWarehouse: '仓库打包中',
    PendingPayment: '待付款',
    ArrivalProcessing: '到着作业中',
    ReceivedPendingOperations: '已收货待作业',
    timeForHomework: '到着作业',
    ArrivalOperations: '处理完成',
    DeliverySigned: '已签收',
    WaitingForCourier: '等待物流公司取件',
    InternationalShipping: '国际运输',
    lookOrder: '查看订单',
    lookWarehouse: '查看仓库',
    lookPorder: '查看配送单',
    dataDisplay: '数据展示',
    seeMore: '查看更多',
    purchaseData: '购买数据',
    ShipmentData: '出货数据',
    CommonShippingLogistics: '常用出货物流',
    shipmentRecord: '出货记录',
    purchaseFrequency: '购买次数',
    TotalPurchaseVolume: '总购买量',
    TotalPurchaseAmount: '总采购额',
    ExpensesIncurredOutsideProduct: '商品以外产生费用',
    AveragePurchasePrice: '平均采购价',
    MinimumPurchasePrice: '最低采购价',
    maxPurchasePrice: '最高采购价',
    NumberShipments: '出货次数',
    ShipmentQuantity: '出货数量',
    DeliveryTime: '出货纳期',
    ProcessingDeliveryTime: '处理纳期',
    DeliverTimCommodityProcurement: '商品采购纳期',
    AverageDeliveryTime: '平均纳期',
    TheSlowest: '最慢',
    Fastest: '最快',
    NumberDefects: '不良次数',
    NumberOfDefects: '不良数量',
    defectRate: '不良率',
    PurchaseQuantity: "购买数量",
    DefectOccurrenceTime: "不良产生时间",
    DefectDescription: "不良说明",
    DefectImage: "不良图片",
    HandlingDecision: "处理决策",
    HandlingCompletionTime: "处理完成时间",
    AdjustedQuantity: "调整后数量",
    PurchaseUnitPrice: "采购单价",
    AdjustedUnitPrice: "调整后单价",
    PurchaseHandlingFee: "采购手续费",
    AdjustedHandlingFee: "调整后手续费",
    AdjustedServiceFee: "调整后服务费",
    AdjustedDomesticShipping: "调整后国内运费",
    SinglePurchaseTotalCost: "单次采购总成本",
    AdjustedTotalCost: "调整后总成本",
    TotalDifference: "总差值",
    procurementDetails: "采购详细",
    procurementQuantity: "采购数量",
    usingLogistics: "使用物流",
    porderDetail: "配送单详细",
    SingleBoxUnpacking: "单箱取消装箱",
    OneCancellatioBoxes: "多箱一键取消",
    SingleProductCancellation: "单商品取消",
    CurrentNumberBoxed: "当前已装箱数",
    CancelPackingMultipleBoxes: "多箱取消装箱",
    ConfirmedWithoutError: "确认无误",
    customizedProducts: "私密货盘",
    CreateProduct: "创建商品",
    SupplementaryImage: "副图",
    ProductDetails: "商品详情",
    editProduct: "编辑商品",
    orderType: "订单类型",
    singleNote: "单番备注",
    progressQuantity: "进行中数量",
    problemProductStatus: "问题产品状态",
    orderPrioritySequence: "下单优先顺序",
    managementNumber: "客户商品管理番号",
    replaceManagementNumber: "更换管理番号",
    beginnerSGuideH5: '新手指南H5',
    kitAssemblyDetails: '组套详细',
    chatHistory: '聊天记录',
    messageContent: '消息内容',
    pendingDepositAmountConfirmation: '待确认入金金额',
    referrerRegistrationSource: '介绍人-注册来源',
    batchReviewProcess: '批量审核',
    productDataAnalysis: '商品数据分析',
    timeFilterSelection: '时间筛选',
    productData: '商品数据',
    taobaoProcurementTotalAmount: '淘宝采购总金额',
    taobaoProcurementLinkQuantity: '淘宝采购链接数量',
    procurementTotalAmount: '1688采购总金额',
    procurementLinkQuantity: '1688采购链接数量',
    factoryData: '工厂数据',
    numberOfTaobaoFactoriesProcured: '采购过的淘宝工厂数量',
    numberOf1688FactoriesProcured: '采购过的1688工厂数量',
    confidentialProductList: '私密货盘',
    numberOfStoresCrawled: '已抓取店铺数',
    numberOfConfidentialProductLinksCrawled: '已抓取私密商品链接数量',
    orderRankingByProductStatistics: '按商品统计下单排名',
    excelExport: 'EXCEL导出',
    ranking: '排名',
    factoryName: '工厂名称',
    factoryLink: '工厂链接',
    platformAffiliation: '所属平台',
    lastPurchaseDate: '最后一次采购日期',
    historicalPurchaseCount: '历史采购次数',
    totalHistoricalPurchaseAmount: '历史采购总金额',
    rankingByFactoryOrderStatistics: '按工厂统计下单排名',
    productName: '商品名称',
    oneClickImportProducts: '一键导入商品',
    productCategoryManagement: '商品分类管理',
    inventoryManagement: '货盘管理',
    batchAddProductsToInventory: '商品批量放入货盘',
    productCategory: '商品分类',
    associatedInventory: '所属货盘',
    supplierName: '供应商名称',
    createFirstLevelCategory: '创建一级类目',
    createSecondLevelCategory: '创建二级类目',
    classificationyName: '分类名称',
    inventoryConfiguration: '货盘配置',
    inventoryName: '货盘名称',
    restrictionCondition: '限制条件',
    useByDefault: '默认使用',
    addNewInventory: '新增货盘',
    createAttribute: '创建属性',
    generateSkuCombination: '生成SKU组合',
    imageUpload: '图片上传',
    addValue: '添加值',
    selectInventoryToJoin: '选择要加入的货盘',
    privateInventoryProductOneClickImport: '私密货盘商品一键导入',
    creationManagementDesignation: '生成系统管理番号',
    storeAuthorization: '店铺授权',
    userNameOrID: '客户名/ID',
    storeType: '店铺类型',
    authorizedStoreId: '授权店铺ID',
    storeProducts: '店铺商品',
    replenishmentLinkCount: '补货链接数量',
    storeAddedDate: '店铺添加日期',
    storeFirstAuthorizationDate: '店铺首次授权日期',
    productUpdateDate: '商品更新日期',
    replenishmentLinkLastUpdated: '补货链接最新更新时间',
    unbind: '解除绑定',
    processProducts: '处理商品',
    disposedProductRemarks: '废弃商品处理备注',
    administrativeHandlingPlan: '行政处理方案',
    businessManagementRemarks: '业务管理备注',
    newArrivalReminder: '上新提醒',
    apiOrderCount: 'api订单数',
    apiOrderLatestTime: 'api订单最新时间',
    apiShippingOrderCount: 'api配送单数',
    apiShippingOrderLatestTime: 'api配送单最新时间',
    productDetailedDescription: '商品详细说明',
    fuzzySearchByManagementNumber: '管理番号模糊搜索',
    pendingRefundQuantity: '待退款数量',
    modifiedAdditionalServices: '修改后附加服务',
    specificProblemDescription: '具体问题描述',
    businessDecisionRemarks: '业务决策备注',
    fbaPickingConfirmationRemarks: 'FBA（配货）确认备注',
    relatedCompensationOrder: '关联赔款单',
    refundQuantityConfirmation: '退款数量确认',
    fbaPickingConfirmation: 'FBA（配货）确认',
    issueSubmissionDuringSale: '售中问题提出',
    realTimeQuantity: '实时数量',
    encodingFormat: '编码格式',
    productManagementBusinessSummary: '商品管理业务汇总',
    productsInProgress: '进行中商品',
    historicalProducts: '历史商品',
    pendingBindingLinksCount: '待绑定链接数',
    managementNumberCount: '管理番号数量',
    maintainedBasicInfo: '已维护基础信息',
    basicInfoPendingMaintenance: '基础信息待维护',
    deactivateManagementNumber: '管理番号停用',
    activateManagementNumber: '管理番号启用',
    batchMaintenance: '批量维护',
    batchIdentification: '批量标识',
    customerProductDataExport: '客户商品数据导出',
    customerProductDataExportAll: '客户商品数据导出(全量)',
    identifier: '标识',
    selectedManagementNumbers: '已选中管理番号',
    oneClickSubmission: '一键提交',
    editRefundQuantity: '退款数量编辑',
    pendingRefundQuantity: '待退款数量',
    submitModification: '提交修改',
    serialNumberStatusFilter: '番号状态筛选',
    optionDescription: 'option说明',
    createMajorCategory: '创建大分类',
    createOptionDescription: '创建option说明',
    majorCategoryName: '大分类名称',
    categoryDescription: '分类说明',
    projectName: '项目名称',
    questionMarkIconDescription: '问号图标说明',
    pageFixedDisplayDescription: '页面固定展示说明',
    regularMemberFeeDescription: '普通会员收费说明',
    fixedRateMemberFeeDescription: '定额会员收费说明',
    svipFeeDescription: 'SVIP收费说明',
    optionImage: 'option图片',
    optionVideo: 'option视频',
    majorCategory: '大分类',
    editOptionDescription: '编辑option说明',
    attachmentDownload: '附件下载',
    openingCount: '开封数',
    wechatAuthorization: '微信授权',
    wechatLogin: '微信登录',
    fullNameInRomanji: '全名（罗马字）',
    editFullNameInRomanji: '全名罗马字编辑',
    amazonDelivery: '纳品数量',
    shelfManagement: '货架管理',
    shelfNumber: '货架编号',
    shelfRemarks: '货架备注',
    storageLocationManagement: '库位管理',
    layerNumber: '库位编号',
    batchSetStorageLocations: '批量设置库位',
    printStorageLocationLabels: '打印库位唛头',
    numberOfLayers: '层数',
    numberOfStorageLocationsInLayer: '该层库位数',
    setStorageLocation: '设置库位',
    printOptions: '打印选项',
    loginToView: '登录可见',
    currentPrice: '当前价格',
    serviceOperation: '服务操作',
    operationQuantity: '操作数量',
    clothLabelProcessing: '布标处理',
    noNeedToGetTrackingNumber: '无需获取物流号',
    batchPrint: '批量打印',
    enterpriseWechatAuthorization: '企业微信授权',
    deliveryOrderAdjustment: '配送单调整',
    addLabelText: '标签文本添加',
    labelEditing: '标签编辑',
    statusChange: '状态变更',
    foldBox: '折盒子',
    recommendedProducts: '推荐商品维护',
    displayImages: '展示图片',
    earliestOperationTime: '最早操作时间',
    settlement: '结汇',
    settlementNumber: '结汇编号',
    settlementAmount: '结汇金额',
    payeeWiseAccountInfo: '收款人万里汇VA账户信息',
    payerWiseAccountInfo: '付款人万里汇VA账户信息',
    settlementAdditionalInfo: '结汇附加信息',
    settlementNotificationTime: '结汇通知时间',
    settlementSuccessTime: '结汇成功时间',
    settlementStatus: '结汇状态',
    moveUp: '上移',
    moveDown: '下移',
    translationEditing: '译文编辑',
    getProductInfo: '获取商品信息',
    currentArrivalQuantity: '本次到货数',
    spotCheck: '抽查',
    taskContentConfiguration: '任务内容配置',
    taskList: '任务列表',
    autoGenerateTasks: '自动生成任务',
    taskType: '任务类型',
    specificRequirements: '具体要求',
    taskTypePreview: '任务类型预览',
    createSpecificRequirements: '创建具体要求',
    specificRequirementsReferenceStandard: '具体要求参考标准',
    lastModifiedTime: '最后一次修改时间',
    typeName: '类型名称',
    taskGroup: '任务群体',
    createTask: '创建任务',
    executor: '执行人',
    taskNumber: '任务编号',
    personInCharge: '负责人',
    spotCheckResult: '抽查结果',
    confirmationStatus: '确认状态',
    spotCheckItems: '抽查项目',
    taskStatus: '任务状态',
    viewAll: '查看全部',
    addCompensation: '新增赔款',
    remindExecutor: '提醒执行人',
    closeTask: '关闭任务',
    emailBlockConfig: '邮件接收设置',
    isEnabled: '是否开启',
    taskGroup: '任务群体',
    executorRatioPendingTasks: '执行人-比例-未完成任务数',
    currentGenerationConditions: '当前生成条件',
    taskResultPreview: '任务结果预览',
    isAbnormal: '是否异常',
    imageRecords: '图片记录',
    remarkRecords: '备注记录',
    closeReason: '关闭原因',
    pleaseSelectTaskType: '请选择任务类型',
    taskDeadline: '任务截止时间',
    messageRecipient: '消息推送人',
    spotCheckItemSelection: '抽查项目选择',
    specificSpotCheckRequirements: '具体抽查要求',
    selectSpotCheckContentFromSystem: '从系统选择抽查内容',
    manuallyAdd: '手动添加',
    currentData: '当前数据',
    spotCheckQuantity: '抽查数量',
    addToTask: '加入任务',
    specificRequirementsSelection: '具体要求选择',
    manuallyAddRequirements: '手动添加要求',
    shipmentQuantity: '出货数',
    logisticsInformation: '物流信息',
    taskGenerationRule: '任务生成规则',
    addNewRule: '新增规则',
    generationCondition: '生成条件',
    historicalAfterSale: '是否历史售后',
    triggerCondition: '触发条件',
    highAmountTrigger: '高额（单番商品金额大于2000）',
    afterSaleHistoryTrigger: '售后历史（历史有过售后的商品）',
    oemTrigger: 'OEM（订单类型为OEM的商品）',
    manualGenerationTrigger: '手动生成（手动生成的任务）',
    deleteThisMethod: '删除该方式',
    saveChanges: '保存修改',
    generationProbability: '生成概率',
    modifyRule: '修改规则',
    deliveryOrderType: '配送单类型',
    optionMatching: 'option匹配',
    deliveryOrderShipmentAmount: '配送单出货金额',
    spotCheckBoxes: '抽查箱子',
    generationTime: '生成时间',
    modifyProductNumber: '修改商品番号',
    rakumartOverseasWarehouseConsolidation: 'RAKUMART海外仓集运',
    selfConsolidation: '自主集运',
    selfConsolidationAuthorizationSettings: '自主集运授权设置',
    selfConsolidationAuthorization: '自主集运授权',
    rkOverseasWarehouseConsolidationAuthSettings: 'RK海外仓集运授权设置',
    rakumartOverseasWarehouseAuthorization: 'Rakumart海外仓授权',
    additionalQuantity: '追加数量',
    basePriceConfigurationList: '底价配置-列表',
    basePrice: '底价',
    basePriceEntry: '底价填写',
    attributeCombination: '属性组合',
    agreedBasePrice: '协议底价',
    isRefundVoucher: '有无退款凭证',
    finalReview: '最终复核',
    internalConfirmation: '内部确认',
    pendingJapanReview: '待日本审核',
    japanReviewRemarks: '日本审核备注',
    pendingMinisterConfirmation: '待部长确认',
    ministerConfirmation: '部长确认',
    requestReReview: '提出复审',
    supplementalScreenshots: '补充截图',
    reReviewReason: '复审原因',
    startReReview: '开始复审',
    reReview: '复审',
    problemDiscoveryToResolutionDuration: '发现问题-解决问题时长',
    durationRating: '发现问题-解决问题时长',
    durationRatingDescription: '时长评分分为1星-5星，星级越高代表时长越短，说明解决得越快',
    ratingStatus: '评分状态',
    specialLabelPrinting: '特殊打印',
    lookContent: '查看内容',
    pickingWorkStatus: '配货工作状况',
    depositWithdrawalModification: '出入金变更',
    applyForDepositWithdrawalModification: '申请出入金变更',
    withAttachedImages: '附带图片',
    depositWithdrawalName: '出入金名义',
    reviewTime: '审核时间',
    reject: '拒绝',
    depositWithdrawalType: '出入金类型',
    depositWithdrawalAmount: '出入金金额',
    modifiedAmount: '变更金额',
    submitApplication: '提交申请',
    confirmModification: '确认变更',
    rejectApplication: '拒绝申请',
    reviewRemarks: '审核备注',
    overseasWarehouseBarcode: '海外仓条码',
    crossGroupOrderAdjustment: '跨组调整订单',
    crossGroupDeliveryOrderAdjustment: '跨组调整配送单',
    temporaryOrder: '临时订单',
    orderExpand: '订单展开',
    customColumns: '自定义表头',
    customOperations: '自定义操作',
    showAllOperations: '全部显示',
    withdrawTranslation: '撤回翻译',
    showAllColumns: '全部显示',
    orderCollapse: '订单收起',
    autoAddMadeInChina: '自动添加Made in China',
    productManagementSyncData: '商品管理同步数据',
    requireAutoSpotCheck: '需要自动抽查',
    smallOrderMinFee: '小客户手续费',
    smallOrderSpecialFee: '小客户特殊收费',
    smallOrderFeeActive: '生效',
    smallOrderFeeInactive: '不生效',
    auxiliaryMaterials: '辅料',
    materialType: '辅料类型',
    materialName: '辅料名称',
    materialNameTrans: '辅料名称译文',
    productManagementNumber: '商品管理番号',
    materialTypeSetting: '辅料类别设置',
    materialAdd: '登记辅料',
    isIncludedInAssessment: '是否纳入考核',
    productLabelDownload: '商品标下载',
    productLabelDownloadFailed: '商品标下载失败',
    outerLabelDialogTitle: '下载配送标 PDF',
    outerLabelFormatTip: '选择文件排版格式',
    outerLabelA4Title: '1页6张',
    outerLabelA4Description: '适合 A4 标签纸，每张 6 个标签',
    outerLabelSingleTitle: '单张',
    outerLabelSingleDescription: '每页一张配送标，标准唛头纸尺寸（必须使用热转印打印，否则可能无法正常显色）',
    outerLabelStartPosition: '指定第一页的开始打印位置',
    outerLabelSelectedPosition: '当前选择：{position}号位',
    outerLabelConfirmDownload: '确认下载',
    outerLabelStartPositionRequired: '请输入1-6的开始打印面',
    shippingLabelDownload: '配送标下载',
    businessFollowUpRemarks: '业务跟单备注',
    whetherIncludedInAssessment: '是否纳入考核',
    ordersNotArrived: '未到货订单',
    purchaseCompletionTime: '采购完成时间',
    replaceLinkEdit: '替换链接编辑',
    customerOrderAttributes: '客户下单属性',
    replaceLink: '替换链接',
    originalLinkData: '原始链接数据',
    currentLinkData: '当前链接数据',
    pendingFollowUpLogisticsList: '待跟进物流列表',
    logisticsDeliveryTime: '物流号发货时间',
    logistics1688SignTime: '物流号1688签收时间',
    originalLink: '替换前链接',
    replacedLink: '替换后链接',
    originalPriceCalculationOption: '原价计算option',
    largeGoodsNumber: '大货数量',
    additionalServicesName: '附加服务名称',
    actualCharges: '收费标准',
    airlineFare: '航空便单价',
    shipFare: '船便的单价',
    whetherReviewed: '是否经过复核',
    originalPriceCalculationSingleDomesticShippingFee: '原价计算国内运费',
    presetTaskList: '预设任务列表',
    taskBasicInformation: '任务基础信息',
    relatedInformation: '关联信息',
    bulkShippingCost: '大货单个运费',
    bulkQuotation: '大货单价',
    presetTask: '预设任务',
    presetTaskCheck: '预抽查',
    appendProduct: '追加商品',
    businessTranslationRemarks: '业务翻译备注',
    autoAskPrice: '自动询货消息设置',
    labelPrinting: '唛头打印',
    generateSupplierOrder: '生成供应商订单',
    CWGroupBatchOperation: 'CW群批量操作',
    confirmOperation: '确认操作',
    operationType: '操作类型',
    pullPeople: '拉人',
    kickOut: '踢人',
    chooseCWGroup: '选择CW群',
    chooseUser: '选择人员',
    chooseCustomerChatGroup: '选择客户聊天群组',
    adminName: '业务员名字',
    quoteData: '报价数据',
    realTimePrice: '实时价格',
    isReplace: '是否补买',
    refundedPendingConfirmation: '已退款待确认',
    hasRefundImage: '是否有凭证',
    isAfterSale: '是否发起售后',
    afterSaleCompletionTimeIn1688: '1688售后完成时间',
    refundedAmountIn1688: '1688退款商品金额CNY',
    incomeAccount: '收入账号（支付宝/银行）',
    arrivalStatus: '到账状况',
    refundArrivalTime: '退款到账时间',
    auditStatus: '审核状态',
    financialAuditRemark: '财务审核备注',
    afterSaleCompletionTimeIn1688: '1688售后完成时间',
    afterSaleOrderNumber: '售后单号',
    customerOrderNumber: '客户订单号',
    refundQuantity: '退款数量',
    problemProductRefundedAmountIn: '问题产品退款商品金额（CNY）',
    problemProductPurchaseProcessingCompletionTime: '问题产品采购处理完成时间',
    refundVoucher: '退款凭证',
    isAfterSaleIn1688: '1688该交易号是否发起售后',
    replenishmentOrder: '补货订单',
    registrationInformation: '登记信息',
    replenishmentTransactionNumber: '补货交易号',
    totalReplenishmentAmountInCNY: '合计补买金额（CNY）',
    detailedExplanation: '详细说明',
    isInternalClaimOrClaimNumber: '是否内部赔款/赔款单号',
    informationSupplementation: '信息补充',
    audit: '审核',
    replenishmentRegistration: '补买登记',
    isInternalClaim: '是否内部赔款',
    orderDetailId: '订单详情ID',
    registration: '登记',
    aftersaleIssueCreate: '问题登记',
    badNumberTotalAmount: '不良合计金额（元）',
    afterSaleProblemDescription: '售后问题说明',
    confirmDetail: '确认明细',
    businessInitialProcessing: '业务初步处理',
    classLeaderDecision: '课长决策',
    businessFinalProcessing: '业务最终处理',
    problemClassification: '问题分类',
    relatedAfterSaleOrder: '关联售后单',
    issueCreate: '问题登记',
    shippingLabelSpec: '配送标规格选择',
    download: '下载',
    autoInquiryProductMessageSettings: '自动询货信息设置',
    defaultSettings: '自动询货消息设置(默认)',
    batchDeleteSettings: '批量删除设置',
    addSingleCustomerSettings: '添加单客户设置',
    messageSettings: '消息设置',
    customerMessageSettings: '客户设置消息',
    chooseCustomer: '选择客户',
    pleaseChooseCustomer: '请选择客户',
    returnAndExchange: '退换货',
    translationTimeStart: '翻译时间开始',
    translationTimeEnd: '翻译时间结束',
    proposeStartTime: '提出开始时间',
    proposeEndTime: '提出结束时间',
    regularWarehouse: '常规仓库',
    sparePartsWarehouse: '备品仓库',
    longTermStorageWarehouse: '长存仓库',
    boxNums: '箱号',
    warehouseInTimeStart: '入库时间-开始',
    warehouseInTimeEnd: '入库时间-结束',
    warehouseStorageDays: '保管天数',
    exportInventory: '库存导出',
    transferToRegularWarehouse: '转入常规商品仓库',
    packBy: '装箱操作人',
    customerCorrespondingPerson: '客户对应人',
    pendingPaymentWarehouseFee: '待支付仓储费（元）',
    warehouseFeePaid: '已产生仓储费（元）',
    boxInnerGoodsValue: '箱内商品价值（元）',
    warehouseAge: '库龄（已保管天数）',
    warehouseInTime: '入库时间（上架时间）',
    boxSize: '箱子尺寸',
    boxInnerGoodsNum: '箱内商品数',
    boxInnerSKUNum: '箱内SKU数',
    expandCollapse: '展开',
    transferOrder: '转库单',
    inventoryTransfer: '库存转移',
    mergeTransferOrder: '转库单合并',
    cancelTransferOrder: '取消转库',
    charge_wms: '装箱完成待入仓',
    packCompleteTime: '装箱完成时间',
    subOrderStatus: '单子状态',
    entireOrderOperationRemark: '整单操作备注',
    targetWarehouse: '目标仓库',
    currentWarehouse: '当前商品所在仓库',
    proposeTransferTime: '提出转库时间',
    operationProductQuantity: '操作商品数量',
    operationProductSerialNumber: '操作商品番数',
    pendingTransferOrder: '待打包转库单',
    transferOrderDetails: '转库单明细',
    operationProductRemark: '单番操作备注',
    transferOrderQuantity: '转库数量',
    transferToLongTermStorageWarehouse: '转入长存仓库',
    movableQuantity: '可移库数',
    singleOperationRemark: '单番操作备注',
    uploadToLongTermStorageWarehouse: '上架到长存仓库',
    longTermStorageFee: '长存仓储费',
    regularStorageFee: '常规仓储费',
    lastModifiedTimes: '最后修改时间',
    currentEffectiveTimes: '当前生效时间',
    priceRange: '价格区间',
    costManagement: '费用管理',
    addWarehouseFeeConfiguration: '新增计费',
    addRegularStorageFee: '新增计费',
    addConfiguration: '新增配置',
    calculationInterval: '计算区间',
    addValuationInterval: '增加计价区间',
    addValuationIntervalTip: '注意事项：区间表示大于左边，小于等于右边，结束值不填默认为上限无穷大。',
    customerLevel: '客户等级',
    threeSidesSum: '三边和',
    priceInYen: '价格（円）',
    priceCategory: '价格类别',
    addRow: '新增一行',
    confirmSubmit: '确认提交',
    pleaseSelectClientLevel: '请选择客户等级',
    pleaseFillPriceRange: '请填写价格区间',
    pleaseSelectTime: '请选择生效日期',
    confirmAddConfiguration: '是否确认新增该配置信息？',
    ddConfiguration: '新增配置',
    updateConfiguration: '更新配置',
    confirmUpdateConfiguration: '是否确认更新该配置信息？',
    longTermStorageWarehouseBill: '长存仓库账单',
    regularWarehouseBill: '常规仓库账单',
    billNumber: '账单号',
    feeBoxNumber: '计费箱数',
    productNumber: '商品数量',
    longTermStorageFeeTotalAmount: '长存仓储费总金额',
    regularStorageFeeTotalAmount: '常规仓储费总金额',
    settlementStatus: '结算状态',
    billDate: '账单日期',
    totalAmount: '总费用',
    longTermStorageFeeName: '长存仓储费',
    regularStorageFeeName: '常规仓储费',
    boxNumber: '箱号',
    dimension: '尺寸(cm)',
    goodsCount: '箱内SKU数',
    goodsNumber: '箱内商品数',
    expand: '展开',
    transferOrderNumber: '转库单号',
    packedQuantity: '已装箱数',
    transferQuantity: '转库数量',
    uncompleted: '未完成',
    completed: '已完成',
    entireOrderOperationRemark: '整单操作备注',
    printBoxLabel: '打印箱子唛头',
    submitToAdmin: '装箱完成提交给行政',
    modifyBoxRules: '修改箱规',
    startPacking: '开始装箱',
    inStockQuantity: '在库数量',
    takeOutQuantity: '出库数量',
    otherBoxesHavePackedNum: '其他箱子已装箱数',
    moveBoxQuantity: '移动数量',
    intoLongTermStorageWarehouse: '入长存仓库',
    rangeStartMustGreaterThanEnd: '区间开始值必须大于区间结束值',
    rangeEndMustGreaterThanStart: '区间结束值必须大于区间开始值',
    cancelPacking: '取消装箱',
    batchExpressUpdate: '批量填写退货物流号',
    singleCheck: '单番核查',
    abnormalArrivalRegistration: '到货异常登记',
    originalInboundOrderNumber: '原入库单号',
    arrivalWarehouseMethod: '到仓方式',
    inboundType: '入库类型',
    trackingNumber: '跟踪单号',
    proposeTime: '提出时间',
    assignmentOrderNumber: '配货订单号',
    thirdPartyOrderNumber: '三方订单号',
    overseasWarehouseAbnormalOrderNumber: '海外仓异常单号',
    productQuantity: '产品数量',
    numberOfSKUs: 'SKU数量',
    preServiceSet: '前置处理设置',
    fbaPreOperator: 'FBA前置操作人员',
    fbaPreOperatorLeader: '检品组长',
    fbaPreOperatorFba: 'FBA人员',
    fbaPreOperatorInspector: '检品单检品员',
    fbaPreOperatorAllLeader: '全选检品组长',
    fbaPreOperatorAllFba: '全选FBA人员',
    fbaPreOperatorAllInspector: '全选检品人员',
    fbaPreAllEnable: '全部设置FBA前置',
    fbaPreAllDisable: '全部取消FBA前置',
    requiredCompletionTime: '要求完成时间',
    serviceOrderType: '服务单类型',
    totalNeedToOperate: '总计需要操作',
    purchaseInformation: '购买信息',
    operationRequirements: '操作要求',
    inspectionLeaderRemark: '检品组长备注',
    operationPersonnelRemark: '操作人员备注',
    goodsSpecification: '货物规格',
    charge: '收费',
    goodsSpecifications: '货物规格',
    operationContent: '操作内容',
    oneClickExpand: '一键展开',
    oneClickCollapse: '一键收起',
    enterTransactionOrLogisticsNumber: '请输入交易号或物流号',
    operationContentNeedsOperationQuantity: '操作内容-需要操作数量',
    forwarder: '提出人',
    totalNeedsOperation: '总计需要操作',
    updateReason: '修改原因',
    serviceType: '服务单类型',
    mechanicalOperationOrder: '机器操作订单总汇',
    fabricLabelOperationOrder: '布标操作单总汇',
    FBAOperationOrder: 'FBA操作单总汇',
    photographyOrder: '摄影操作单总汇',
    viewServiceOrderDetail: '查看服务单明细',
    updateQuantity: '修改数量',
    updateRemark: '修改备注',
    directCompletion: '配货直接完成',
    businessRemarkographyOrderRemark: '业务摄影订单备注',
    reGenerateInboundPlan: '重新生成纳品计划',
    reGenerate: '重新生成',
    reGenerateSuccess: '纳品计划生成成功!',
    deliveryFollowUpRemarks: '配货跟单备注',
    openedQuantity: '开封数量',
    viewQuestionnaire: '查看问卷',
    apiManagement: 'api管理',
    purchasePayCheckList: '交易号平台支付比对列表',
    processed: '已处理',
    allOfTheComparison: '全部比对',
    platformPaymentStatus: '平台支付状态',
    transactionNumber: '交易号',
    orderNumber: '订单号',
    fromPlatform: '来源平台',
    clientName: '客户姓名',
    amountMatchStatus: '金额匹配状态',
    sorting: '番号排序',
    totalQuantity: '交易号内商品数量',
    customer: '客户',
    createTime: '创建时间',
    lastCheckCheckTime: '最后核查时间',
    totalPurchaseAmount: '',
    handleStatus: '处理状态',
    totalPayableAmount: '客户总付款',
    unmatchedReason: '不匹配原因',
    totalPaymentAmount: '总支付金额',
    buyAccount: '购买账户',
    purchaseCost: '采购填写成本',
    actualPaymentAmount: '1688应付款',
    financialRemark: '财务备注',
    generatePaymentLinks: '批量生成支付链接',
    markProcessed: '标记处理',
    areYouSureToMarkProcessed: '是否确认标记处理选中的订单？',
    purchasePayCheckDeal: '采购支付比对处理',
    areYouSureToPurchasePayCheckDeal: '是否标记该交易号已经处理完成？',
    areYouSureToGeneratePaymentLinks: '是否确认批量生成支付链接选中的订单？',
    purchaseNoNotInSystemList: '异常交易号跟进列表',
    isPayable: '是否可支付',
    worldfirstCheckList: '出金异常数据',
    purchaseChengBen: '采购成本',
    serviceOrderSplit: '服务单拆分',
    fingerprintCollection: '指纹采集',
    supplementalMaterials: '补充资料',
    purchasePayCheckPurchaseList: '待财务付款跟进',
    depositTime: '入金时间',
    apiBindingIdentifier: 'API绑定标识',
    businessTemporaryRemarks: '业务订单翻译备注',
    manualOrder: '手动下单',
    excelOrder: 'EXCEL下单',
    addGoods: '提出新订单',
    personAdjustment: '人员调整',
    orderTypeEdit: '订单类型编辑',
    deleteOrder: '删除订单',
    deleteOrderRemark: '删除订单备注',
    pleaseEnterTheDeleteReason: '请输入删除原因',
    immediateAdjustment: '立即调整',
    relatedDeliveryOrder: '关联配送单',
    andSingle: '并单',
    productInformationEntry: '商品信息录入',
    productInfoRecordSettings: '商品信息记录设置',
    productInfoTask: '商品信息任务',
    needRecord: '需要记录',
    noNeedRecord: '无需记录',
    serviceOperationDuration: '服务操作时长',
    goodsWeightSize: '商品重量尺寸',
    taskExecutionOrder: '任务执行订单',
    taskRequirements: '任务要求',
    commodityInformationEntry: '业务商品信息录入表单',
    assignmentCommodityInformationEntry: '配货商品信息录入表单',
    editExecutor: '修改执行人',
    businessCommodityInformationEntry: '业务商品信息录入表单',
    normalInspectionOperationDuration: '普通检品操作时长(单个)',
    additionalServiceOperationDuration: '附加服务（单个服务操作时长）',
    repurchaseCount: '复购次数',
    transferBox: '转库箱子',
    packDateStart: '提出转库开始时间',
    packDateEnd: '提出转库结束时间',
    transferApplyBy: '提出转库人',
    distributionBoxRemark: '配货箱子备注',
    businessBoxRemark: '业务箱子备注',
    administrativeExtractionTime: '行政取出时间',
    warehouseAgeMin: '库龄-最小值',
    warehouseAgeMax: '库龄-最大值',
    cancelHandoverApplication: '取消交接申请',
    takeOutToDistribution: '取出给配货',
    warehouseAgeTitle: '库龄',
    storedDays: '已保管天数',
    orderNumberMash: '订单号/番号',
    pendingDistributionConfirm: '待配货确认',
    waitPutIntoLongTermStorageWarehouse: '等待放入长存仓库',
    waitTakeOutFromLongTermStorageWarehouse: '等待从长存仓库取出',
    pendingDistributionShelf: '待配货上架',
    collapse: '收起',
    red: '红色',
    temporaryArea: '临时区域',
    outOfShelfApplyBy: '出库提出人',
    outOfShelfApplyTime: '出库提出时间',
    cancelTransfer: '取消转库',
    confirmSubmitToAdministration: '确认提交给行政',
    returnToRegularWarehouse: '退回普通仓库',
    uploadToRegularWarehouse: '上架到常规商品仓库',
    // 直接装箱箱子
    directPackingBox: '直接装箱箱子',
    packCompleteWaitShip: '装箱完成待出货',
    packTime: '装箱时间',
    boxStatus: '箱子状态',
    unshippedOrder: '未出货订单',
    locationInfo: '库位信息',
    customerOrderRemark: '客户订单备注',
    distributionPackRemark: '配货装箱备注',
    salesPackRemark: '业务员装箱备注',
    returnToPacking: '退回装箱中',
    personnelScope: '人员范围',
    shelfType: '库位类型',
    normalShelf: '普通库位',
    chargeShelf: '长存仓库',
    inboundDate: '入库日期',
    outboundDate: '出库日期',
    packCompleteInboundTime: '装箱完成时间（入库）',
    belongingPorder: '所在配送单',
    proposedToPorder: '已提出到配送单',
    convertFreightToOrderBoxConfirm: '是否将当前配送单内商品转入长存仓库，<br>确认后将生成转库交接单，由行政进行移库上架操作。<br>确认后无法回退。',
    confirmProposeTransfer: '确认提出转库',
    noTransferableBox: '当前配送单没有可转移的箱子',
    longTermStorageFeeBill: '长存仓储费账单',
    longTermStorageFeeConfiguration: '长存仓储费配置',
    warehouseFeeTotalAmount: '仓储费金额',
    warehouseFeeName: '仓储费',
    // 辅料列表
    materialList: '辅料列表',
    materialOperation: '辅料操作',
    createMaterial: '创建辅料',
    selectOneProductToCreateMaterial: '请选择一个番创建辅料',
    transactionLogisticsOperation: '交易/物流号操作',
    markAsMaterial: '标识商品为辅料',
    confirmMarkAsMaterial: '标识为辅料',
    confirmMarkSelectedAsMaterial: '是否把勾选的商品标识为辅料，注意，如果商品已经绑定过辅料，将无法标识，请确认无误后再操作',
    cancelMaterialMark: '取消辅料标识',
    confirmCancelMaterialMark: '是否取消已勾选商品的辅料标识.',
    confirmChangeMaterialConsume: '是否确认变更消耗点数，变更后，商品出货将按照新消耗点数扣除辅料库存。',
    bindMaterialUsage: '绑定辅料使用',
    pleaseSelectMaterial: '请选择辅料',
    customerIdRequired: '客户ID不能为空',
    boundMaterialCannotMark: '已绑定辅料的商品无法标识为辅料',
    markedMaterialCannotBind: '已标识为辅料的商品无法绑定辅料',
    materialRelationConflict: '商品不能同时标识为辅料并绑定辅料',
    customerNameOrID: '客户名/ID',
    materialId: '辅料ID',
    noStock: '无库存',
    stockInsufficient: '库存不足',
    stockSufficient: '库存充足',
    suggestReplenishment: '建议补货',
    actualStockQuantity: '实际库存数量',
    expectedConsumptionQuantity: '预计消耗数量',
    expectedReplenishmentQuantity: '预计补货数量',
    expectedConsumption: '预计消耗',
    pointsPerSet: '点/套',
    materialInOrder: '辅料所在订单',
    remainingPoints: '剩余点数',
    point: '点',
    materialEdit: '编辑',
    confirmDeleteMaterial: '确认删除该辅料吗？',
    // 辅料详情 - 基础信息与媒体上传
    materialDetail: '辅料详情',
    materialInfo: '辅料信息',
    uploadMainImage: '上传主图',
    defaultConsumption: '默认消耗',
    materialDocumentFiles: '资料文件',
    boundOrderPlanList: '绑定商品管理番号',
    batchBind: '批量绑定',
    batchBindOrderPlan: '批量绑定下单方案',
    orderPlanTagNo: '方案标签号',
    orderPlanRemark: '业务备注关键词',
    boundMaterialList: '已绑定的辅料',
    selectAll: '全选',
    // 辅料详情 - 已标识商品与消耗展示
    boundOrderList: '已绑定订单',
    markedProductList: '已标识商品',
    materialConsumption: '消耗',
    singleConsumption: '单次',
    expectedValue: '预计',
    unmark: '解除',
    confirmUnmarkMaterial: '确认解除该商品的辅料标识吗？',
    // 辅料详情 - 订单绑定辅料使用
    orderBindMaterialUsage: '订单绑定辅料使用',
    actualPurchaseQuantity: '实际购买数',
    shippedQuantity: '已出库数',
    estimatedAvailableQuantity: '预计可用数',
    consumptionPerSet: '每套消耗点数',
    estimatedConsumptionPoints: '预计消耗点数',
    unbindMaterial: '解除绑定',
    confirmUnbindMaterial: '解除绑定后，该商品将不会继续扣除辅料，是否确认解除绑定？',
    // 辅料详情 - 库存信息与预估自动消耗记录
    stockInfo: '库存信息',
    estimatedAutoConsumptionRecord: '预估自动消耗记录',
    systemAutomaticUsageRecord: '系统使用记录',
    consumptionDetail: '消耗明细',
    porderSn: '配送单号',
    consumedPoints: '消耗点数',
    returnedToWarehouse: '回退到仓库',
    stockIn: '入库',
    // 辅料详情 - 注意事项、弹窗和校验提示
    otherInfo: '其他信息',
    pleaseEnterMattersNeedingAttention: '请输入注意事项',
    editMaterialName: '修改辅料名称',
    pleaseEnterMaterialName: '请输入辅料名称',
    pleaseUploadImage: '请上传图片',
    recordTime: '时间',
    confirmDeleteMaterialImage: '确认删除该图片吗？',
    confirmDeleteMaterialFile: '确认删除该文件吗？',
    cancelOutboundApplication: '取消出库申请',
    productWeightEntry: '商品重量录入',
    materialManagement: '辅料管理',
    orderPlan: '下单方案',
    createPlan: '创建方案',
    editPlan: '编辑方案',
    confirmDeletePlan: '确认删除该方案吗？',
    generateDefaultPlan: '生成默认方案',
    defaultOrder: '默认下单',
    mainProductInfo: '主商品信息',
    comboProductInfo: '组套商品信息',
    comboProduct: '组套商品',
    materialBinding: '辅料绑定',
    pointPerSet: '点/套',
    labelNumber: '标签番号',
    labelText: '标签文本',
    noOrderPlan: '暂无下单方案',
    planLatestUpdateTime: '方案最新更新时间',
    listView: '列表视图',
    cardView: '卡片视图',
    planName: '方案名称',
    pleaseEnterPlanName: '这里是方案名称...',
    defaultOrderUse: '默认下单使用',
    orderLink: '下单链接',
    addMatchingProduct: '添加配套商品',
    mainProduct: '主商品',
    matchingProduct: '配套商品',
    matchingProductName: '配套商品名称',
    useLatestOrderLink: '使用最新下单链接',
    orderLinkSupportTip: '目前支持1688,淘宝,天猫,拼多多,京东,微店,苏宁易购等国内平台，不支持其他平台。如果商品为私密商品，下单后人工处理',
    productAttributes: '商品属性',
    purchasePrice: '进货价',
    clickToSelect: '点击选择',
    addNewTag: '添加新标签',
    labelType: '标签类型',
    pleaseSelectLabelType: '请选择标签类型',
    pleaseEnterLabelNumber: '请输入标签番号（SKU）',
    pleaseEnterCommodityCode: '请输入商品编码（ASIN/商品URL）',
    pleaseEnterLabelText: '请输入标签文本内容',
    selectMaintainedTag: '选择已维护标签',
    materialUsage: '辅料使用',
    noTag: '暂无标签',
    noHistoryTag: '暂无历史标签',
    noMaintainedTag: '暂无已维护标签',
    noBoundMaterial: '暂无绑定辅料',
    queryMaterialStockGrids: '查看库位',
    materialCurrentStock: '当前库存',
    noMaterialStockGrids: '暂无库位库存',
    materialMasterIdRequired: '缺少有效的辅料主档ID',
    noMaterial: '暂无辅料',
    noAdditionalServices: '暂无附加服务',
    inventoryQuantity: '库存数量',
    saveSuccess: '保存成功',
    customerRemarks: '客户备注',
    addComboProduct: '添加组套商品',
    comboItem: '同捆物',
    comboChildLimitTip: '组套最多绑定3个子商品',
    enableThisPlan: '使用',
    pleaseSelectMainProductAttribute: '请先选择主商品属性',
    platformBillList: '平台账单',
    platformBillOrderId: '交易编号',
    platformBillCreateTime: '交易创建时间',
    platformBillCurrency: '币种',
    platformBillDisplayType: '展示类型',
    platformBillDirection: '资金方向',
    platformBillTransactingPart: '交易对手',
    platformBillTransactionId: '交易ID',
    platformBillAccountId: '账户ID',
    platformBillType: '交易类型',
    platformBillDescription: '交易描述',
    platformBillTransactionTime: '交易发生时间',
    platformBillRunningBalance: '交易后余额',
    platformBillFeeExport: '账单费用导出',
    platformBillFeeExportFail: '账单费用导出失败',
    platformBillAmountTotal: '合计金额',
    platformBillServiceFeeTotal: '合计手续费',
    platformBillOrderSnPlaceholder: '请输入订单号',
    platformBillOrderIdPlaceholder: '请输入交易编号',
    platformBillDisplayTypePlaceholder: '请输入展示类型',
    pleaseSelectBillingType: '请选择账单类型',
    pleaseSelectDateRange: '请选择开始和结束时间',
    platformBillAccountCenter: '账户中心',
    chinaAccounts: '中国账户',
    japanAccounts: '日本账户',
    accountCenterAccountUnit: '个账户',
    hideAccountBalance: '隐藏余额',
    showAccountBalance: '显示余额',
    accountBalanceUpdatedAt: '更新时间',
    accountCurrencyCny: '人民币',
    accountCurrencyJpy: '日本円',
    productInquiry: '商品询盘',
    inquiryQuestion: '询盘问题',
    inquiryQuestionPlaceholder: '请输入统一询盘问题',
    pleaseEnterInquiryQuestion: '请输入询盘问题',
    inquiryRecords: '商品询盘记录',
    noInquiryRecords: '暂无询盘记录',
    taskId: '任务ID',
    refinedAnswers: '提炼问答',
    noRefinedAnswers: '暂无提炼结果',
    dialogueContent: '具体对话内容',
    noDialogueContent: '暂无对话内容',
    productManagementV2: '商品管理V2',
    productV2AllProducts: '所有商品',
    productV2PendingMaintenance: '待维护',
    productV2Maintaining: '维护中',
    productV2PendingAudit: '待审核',
    productV2MaintenanceCompleted: '维护完了',
    productV2Normal: '正常',
    productV2Hidden: '隐藏',
    productV2Yes: '是',
    productV2No: '否',
    productV2CreateProduct: '创建商品',
    productV2BatchSubmitAudit: '批量提交审核',
    productV2BatchNoNeed: '批量提交无需维护',
    productV2BatchAudit: '批量审核',
    productV2RaiseOrderCheck: '提出订单校验',
    productV2ProductName: '商品名称',
    productV2ProductInfo: '商品信息',
    productV2PurchaseLink: '购买链接',
    productV2View: '查看',
    productV2BusinessRemark: '业务备注',
    productV2Maintain: '维护',
    productV2SelectProduct: '请选择要操作的商品',
    productV2ConfirmOperation: '确认执行当前操作？',
    productV2EditManagementCode: '修改商品管理番号',
    productV2EnterManagementCode: '请输入商品管理番号',
    productV2CompleteCreateInfo: '请填写客户和商品管理番号',
    productV2Loading: '正在加载...',
    productV2NoData: '暂无商品数据',
    productV2Total: '总计 {total} 件',
    productV2PageSize: '件/页',
    productV2PlanSelection: '方案选择',
    productV2PurchaseRequirement: '采购调查要求',
    productV2AllocationRequirement: '配货要求',
    productV2InspectionRequirement: '检品要求',
    productV2OrderHistory: '下单记录',
    productV2OrderHistoryTip: '录入管理番号进行维护后，系统根据商品明细ID和属性，每周期更新历史订单数据',
    productV2ViewAll: '查看全部>>',
    productV2ManagementCodeStatus: '管理番号状态',
    productV2Enabled: '启用',
    productV2ViewPlanId: '查看方案ID',
    productV2DeletePrompt: '删除提示',
    productV2DeleteWarning: '以下选中的商品管理数据是否删除，删除后数据不在保留，请谨慎操作',
    productV2SubmitAuditPrompt: '提交审核提示',
    productV2SubmitAuditWarning: '以下选中的管理番号是否批量提交审核',
    productV2RaiseOrderPrompt: '提示',
    productV2RaiseOrderWarning: '以下管理番号商品没设置下单相关信息，请设置完成后重新提出订单',
    productV2PlanMaintain: '售卖方案维护',
    productV2SameCustomerOrder: '提出订单时只能选择同一客户的管理番号',
    productV2SelectedCount: '勾选数量',
    productV2SelectedList: '已勾选商品',
    productV2NoSelected: '暂无勾选商品',
    productV2SpuBind: 'SPU绑定',
    productV2CurrentBoundSpu: '当前已绑定SPU:',
    productV2SpuSearchPlaceholder: 'SPU / 名称 模糊匹配',
    productV2CreateSpu: '创建SPU',
    productV2SpuName: '名称',
    productV2Bind: '绑定',
    productV2Unbind: '解绑',
    productV2BindNow: '立即绑定',
    productV2SpuSaveTitle: 'SPU创建 /编辑',
    productV2EnterSpu: '请输入SPU',
    productV2EnterSpuName: '请输入名称',
    productV2UploadImage: '上传图片',
    productV2SpuDeleteWarning: '删除SPU后，所有绑定了该SPU的管理番号将自动解除绑定，无法回退，请确认后删除。',
    confirmDeletion: '确认删除',
    // 客户仓库改版顶部文案
    warehouseBulkStorage: '散货存放',
    warehouseBoxStorage: '整箱存放',
    warehouseNormalGoods: '普通商品',
    warehouseMaterialGoods: '辅料',
    warehouseSearchItem: '搜索项目',
    warehouseOrderSnAsc: '订单号升序',
    warehouseOrderSnDesc: '订单号降序（默认）',
    warehouseForSnAsc: '管理番号升序',
    warehouseForSnDesc: '管理番号降序',
    warehouseStorageDaysAsc: '保管天数升序',
    warehouseStorageDaysDesc: '保管天数降序',
    warehouseTagNo: '标签号',
    warehouseGoodsCode: '商品码',
    // 客户仓库“全部”列表文案
    warehouseStorageInfo: '仓库保管情报',
    warehouseWmsRemark: '仓库备注',
    warehouseSubmittedCount: '已提出数',
    warehouseAvailableCount: '可提出数',
    // 捆包列表字段
    warehousePackingCount: '捆包数',
    // 客户仓库配送单预览文案
    warehouseDeliveryPreview: '自动追加辅料确认',
    warehouseDeliveryPreviewWarning: '注意：系统只能自动把库存数量足够的部分加入配送单，辅料无库存时无法自动计算并加入配送单。',
    warehouseShipmentQuantityInvalid: '出货数必须为大于0的整数',
    confirmSubmission: '确认提出',
    // 客户仓库底部批量操作栏文案
    warehouseSelectAll: '全选',
    warehouseAutoCalculateMaterial: '自动计算辅料',
    warehousePoints: '点',
    yuan: '元',
    warehouseNoData: '暂无仓库商品',
    warehouseTabPending: '该仓库列表将在后续阶段实现',
    warehouseExpand: '展开',
    warehouseOrderRemark: '订单管理备注',
    warehouseSubaccount: '下单子账号',
    warehouseStorageInformation: '仓库保管信息',
    warehouseRemainingFreeDays: '剩余免费保管天数',
    warehouseForbiddenGoods: '禁运',
    warehouseExchangeRate: '订单汇率',
    warehouseCurrentStock: '仓库数量',
    warehouseBoxedCount: '装箱数量',
    warehousePendingCount: '待提出数量',
    warehouseUnboxedCount: '未装箱数量',
    warehouseMaterialType: '辅料类型',
    warehouseMaterialConsume: '消耗数量',
    warehouseBoundMaterial: '已绑定辅料',
    warehouseUnboundMaterial: '未绑定辅料',
    warehouseFirstInboundAt: '首次入库时间',
    warehouseFirstPurchaseInboundAt: '首次采购入库时间',
    warehouseUsedFreeDays: '已用免费天数',
    warehouseExporting: '仓库数据导出中',
    warehouseExportFailed: '仓库数据导出失败',
    productAuditType: '审核类型',
    productNormal: '正常商品',
    productNoNeedToMaintain: '无需维护',
    warehouseStorageDays: '保管日数',

  },
}
